export default {
  translation: {
    apiError: {
      INVALID_INPUT: 'Invalid input. Please check your data.',
      NOT_FOUND: 'The requested resource was not found.',
      INTERNAL_ERROR: 'Internal server error. Please try again later.',
      UNAUTHORIZED: 'Authentication required. Please sign in.',
      FORBIDDEN:
        'Access denied. You do not have permission to perform this action.',
      CONTENT_POLICY_VIOLATION:
        'Sorry, I cannot answer this question.\n\nIn emergencies, please contact medical or psychological professionals or your local emergency services.',
      CONNECTION_ERROR:
        'Connection error. Please check your network connection.',
    },
    common: {
      delete: 'Delete',
      deleteModalTitle: 'Are you sure to delete this item?',
      evaluation: 'Evaluation',
      ok: 'Yes',
      cancel: 'Cancel',
      total: 'Total',
      rename: 'Rename',
      name: 'Name',
      save: 'Save',
      namePlaceholder: 'Please input name',
      next: 'Next',
      create: 'Create',
      edit: 'Edit',
      upload: 'Upload',
      english: 'English',
      german: 'German',
      spanish: 'Spanish',
      french: 'French',
      italian: 'Italian',
      dutch: 'Dutch',
      portuguese: 'Portuguese',
      russian: 'Russian',
      polish: 'Polish',
      romanian: 'Romanian',
      turkish: 'Turkish',
      ukrainian: 'Ukrainian',
      arabic: 'Arabic',
      bosnian: 'Bosnian',
      chinese: 'Simplified Chinese',
      traditionalChinese: 'Traditional Chinese',
      language: 'Language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'select your language',
      copy: 'Copy',
      copied: 'Copied',
      comingSoon: 'Coming soon',
      download: 'Download',
      close: 'Close',
      preview: 'Preview',
      move: 'Move',
      warn: 'Warn',
      action: 'Action',
      s: 'S',
      pleaseSelect: 'Please select',
      pleaseInput: 'Please input',
      submit: 'Submit',
      embedIntoSite: 'Embed into webpage',
      previousPage: 'Previous',
      nextPage: 'Next',
      import: 'Import',
      detail: 'Details',
      editSuccess: 'Successfully updated',
      createSuccess: 'Successfully created',
      operationFailed: 'Operation failed',
      properties: 'Properties',
      propertyName: 'Property name',
      nameRequired: 'Name is required',
      addProperty: 'Add property',
      addItem: 'Add item',
      itemCount: 'Items',
      createTime: 'Created',
      search: 'Search',
      description: 'Description',
      required: 'Required',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Failed to save',
      more: 'More',
      less: 'Less',
      duplicate: 'Duplicate',
    },
    login: {
      login: 'Sign in',
      loginDescription: 'We’re so excited to see you again!',
      emailLabel: 'Email',
      emailPlaceholder: 'Please input email',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Please input password',
      rememberMe: 'Remember me',
      incorrectCredentials: 'Email or password is incorrect.',
      title: 'Start building your smart assistants.',
      description:
        'Sign up for free to explore top RAG technology. Create knowledge bases and AIs to empower your business.',
      review: 'from 500+ reviews',
    },
    passwordStrength: {
      tooWeak: 'Too weak',
      weak: 'Weak',
      fair: 'Fair',
      strong: 'Strong',
    },
    header: {
      knowledgeBase: 'Knowledge',
      chat: 'Buddys',
      register: 'Register',
      signin: 'Sign in',
      home: 'Home',
      setting: 'User settings',
      logout: 'Log out',
      fileManager: 'File Management',
      flow: 'Workflows',
      search: 'Quick Test',
    },
    knowledgeList: {
      welcome: 'Welcome back',
      description: 'Which knowledge bases will you use today?',
      createKnowledgeBase: 'Create knowledge base',
      name: 'Name',
      namePlaceholder: 'Please input name!',
      doc: 'Docs',
      searchKnowledgePlaceholder: 'Search',
      noMoreData: 'All knowledge bases have been loaded.',
      crawlScheduleActive:
        'Automatic crawler active – this knowledge base is crawled on a schedule',
    },
    knowledgeDetails: {
      dataset: 'Dataset',
      testing: 'Retrieval testing',
      crawler: 'Crawler',
      files: 'files',
      configuration: 'Configuration',
      name: 'Name',
      namePlaceholder: 'Please input name!',
      doc: 'Docs',
      addFile: 'Add contents',
      searchFiles: 'Search your files',
      localFiles: 'Local files',
      emptyFiles: 'Create empty file',
      webCrawl: 'Web Crawl',
      chunkNumber: 'Chunk Number',
      uploadDate: 'Upload Date',
      publicationYear: 'Publication Year',
      publicationYearTip:
        'The year the content itself was published — not when it was uploaded here. Leave empty if unknown; the assistant is told the year only for documents that have one.',
      publicationYearPlaceholder: 'e.g. 2024',
      publicationYearInvalid: 'Enter a year between {{min}} and {{max}}.',
      chunkMethod: 'Chunk Method',
      enabled: 'Enable',
      showInReferences: 'Display',
      disabled: 'Disable',
      action: 'Action',
      parsingStatus: 'Parsing Status',
      commonTags: 'Keywords',
      processBeginAt: 'Begin at',
      processDuration: 'Duration',
      progressMsg: 'Progress',
      crawlReport: 'Crawl Report',
      crawlReportStartUrl: 'Start URL',
      crawlReportSummary: 'Summary',
      crawlReportSummaryText:
        '{{total}} pages total, {{successful}} succeeded, {{errors}} failed.',
      crawlReportSuccessfulPages: 'Successful pages',
      crawlReportUrl: 'URL',
      crawlReportStatusCode: 'Status code',
      crawlReportErrorMessage: 'Error message',
      crawlReportReason: 'Likely cause',
      crawlReportTitle: 'Title',
      crawlReportNotAvailable: 'No crawl report available yet.',
      crawlReportNoErrors: 'No errors — all pages crawled successfully.',
      crawlReportDownload: 'Download report',
      crawlReportConfig: 'Crawl configuration',
      crawlReportOutcome: 'Outcome',
      crawlReportOutcomeNew: 'New',
      crawlReportOutcomeUpdated: 'Updated',
      crawlReportOutcomeUnchanged: 'Unchanged — skipped',
      crawlReportDelta: 'Since last run',
      crawlReportDeltaText:
        '{{new}} new, {{updated}} updated, {{unchanged}} unchanged (not re-analyzed).',
      crawlReportNotAnalyzed:
        'Analysis after crawl was disabled for this run — pages were crawled and saved as documents, but not parsed or embedded. Run them manually from the Dataset tab if needed.',
      crawlReportCancelledTitle: 'This crawl was stopped early',
      crawlReportCancelledDescription:
        'It was cancelled after checking {{total}} pages — there may be more pages on the site that were not reached yet.',
      crawlReportRemoved: 'Removed since last run',
      crawlReportRemovedText:
        '{{removed}} page(s) previously crawled from this source were deleted because they were missing from this run.',
      crawlReportRemovedPages: 'Removed pages',
      crawlReportDeletionSkippedCancelled:
        'Delete missing pages was enabled, but this run was cancelled — no pages were deleted, since a stopped crawl may not have reached pages that still exist.',
      crawlReportDeletionSkippedMaxPagesFirstHit:
        'Delete missing pages was enabled, but this run hit its Max Pages limit for the first time — no pages were deleted, since there is no earlier capped run to confirm a missing page is really gone rather than just out of reach this time.',
      crawlReportDeletionSkippedNoPagesFetched:
        "Delete missing pages was enabled, but this run didn't successfully fetch a single page — no pages were deleted, since a failed crawl (site unreachable, expired login, a blocked start page) can't tell a deleted page apart from one it simply couldn't reach.",
      crawlReportDeletionSkippedMaxPagesChanged:
        "Delete missing pages was enabled, but this run's Max Pages limit is different from the previous capped run's — no pages were deleted, since comparing two different limits isn't reliable evidence that a page is really gone.",
      crawlReportDeletionSkippedConfigChanged:
        'Delete missing pages was enabled, but a setting that affects which pages this crawl can reach (start URL, discovery mode, max depth, or a URL/type filter) changed since the previous run — no pages were deleted, since a page can fall outside a narrower configuration without being removed from the site.',
      crawlSourceAnalyzeAfterCrawl: 'Analyze after crawl',
      crawlSourceAnalyzeAfterCrawlTooltip:
        'When enabled (default), crawled pages are automatically parsed and embedded right after the crawl finishes. When disabled, pages are still crawled and saved as documents, but left unanalyzed until run manually.',
      crawlSourceIncludeImagesInChangeDetection:
        'Count images for change detection',
      crawlSourceIncludeImagesInChangeDetectionTooltip:
        'When enabled (default), a page is treated as changed on re-crawl if any of its image references changed. When disabled, image references are ignored when deciding whether a page changed — so a page whose text is unchanged is not re-ingested just because an image URL rotated (e.g. cache-busted assets). Applies to HTML pages only; PDFs are always compared in full.',
      crawlSourceDeleteMissingPages: 'Delete pages missing from latest crawl',
      crawlSourceDeleteMissingPagesTooltip:
        'When enabled, a page previously crawled from this source that is no longer found in a run is deleted (document, chunks and file) — treated as removed from the site. When disabled (default), such pages are left untouched. Skipped for a cancelled run, or a run hitting Max Pages for the first time, since "missing" is not reliable evidence of deletion in those cases.',
      crawlSourceDeleteMissingPagesDeepCrawlWarning:
        'With Deep Crawl (link-following) discovery, a page can be missing from a run simply because nothing currently links to it, not because it was removed from the site. Sitemap discovery is a more reliable signal for this setting.',
      crawlSourceDescription:
        'Save reusable web-crawl configurations and run them again whenever the source content changes. A crawl source only ingests new or changed pages on each run.',
      crawlSourceCreate: 'New crawl source',
      crawlSourceEdit: 'Edit crawl source',
      crawlSourceName: 'Name',
      crawlSourceNamePlaceholder: 'Please input a name!',
      crawlSourceStartUrl: 'Start URL',
      crawlSourceStatus: 'Status',
      crawlSourceLastRun: 'Last run',
      crawlSourceNeverRun: 'Never run',
      crawlSourceRunNotFinished: 'Not finished yet',
      crawlSourceRunNow: 'Run now',
      crawlSourceStop: 'Stop this run',
      crawlSourceAlreadyRunning: 'A run is already in progress',
      crawlSourceRunHistory: 'Run history',
      crawlSourceRunHistoryEmpty: 'No runs yet.',
      crawlSourceRunDate: 'Date',
      crawlSourceRunDone: 'Done',
      crawlSourceRefresh: 'Refresh',
      crawlSourceBackToHistory: 'Back to history',
      crawlSourceViewReport: 'View report',
      crawlSourceDelete: 'Delete',
      crawlSourceCannotDeleteRunning:
        'Stop the run and let it finish before deleting',
      crawlSourceDeleteConfirm:
        'Are you sure you want to delete this crawl source? Documents it already created are not affected.',
      crawlRunDelete: 'Delete',
      crawlRunDeleteConfirm:
        'Are you sure you want to delete this run? Its history record and report are removed permanently. Documents it already created are not affected.',
      crawlRunCannotDeleteLatest:
        "Can't delete the most recent run — it's what the Status column shows.",
      crawlSourceEmpty: 'No crawl sources yet.',
      crawlSourceCreateSuccess: 'Crawl source created.',
      crawlSourceUpdateSuccess: 'Crawl source updated.',
      crawlSourceDeleteSuccess: 'Crawl source deleted.',
      crawlSourceRunStarted:
        'Crawl started — check back for its report shortly.',
      crawlSourceCrawling: 'Crawling',
      crawlSourceStopping: 'Stopping…',
      crawlSourceStoppingHint:
        'Finishing the current batch before it halts — this may take a moment.',
      crawlSourceCrawlFailed: 'Crawl failed',
      crawlSourceCrawlCancelled: 'Crawl cancelled',
      crawlSourcePagesProcessed: '{{done}} of {{total}} pages processed',
      crawlSourcePagesNotAnalyzed: '{{total}} pages crawled, not analyzed',
      crawlSourcePagesFailed: '{{count}} failed',
      crawlSourcePagesCancelled: '{{count}} cancelled',
      crawlSourcePagesNotAnalyzedCount: '{{count}} not analyzed',
      crawlSourceSchedule: 'Schedule',
      crawlSourceScheduleOff: 'Off',
      crawlSourceScheduleEdit: 'Edit schedule',
      crawlSourceScheduleTitle: 'Recurring schedule',
      crawlSourceScheduleEnabled: 'Run automatically',
      crawlSourceScheduleFrequency: 'Frequency',
      crawlSourceScheduleWeekly: 'Weekly',
      crawlSourceScheduleMonthly: 'Monthly',
      crawlSourceScheduleDayOfWeek: 'Day of week',
      crawlSourceScheduleDayOfMonth: 'Day of month',
      crawlSourceScheduleTime: 'Time',
      crawlSourceScheduleEndDate: 'End date',
      crawlSourceScheduleEndDateHint: 'Optional — no runs after this date.',
      crawlSourceScheduleDayOfMonthHint:
        'Months shorter than the chosen day run on their last day.',
      crawlSourceScheduleUpdateSuccess: 'Schedule updated.',
      crawlSourceScheduleSummaryMonthly: 'day {{day}}',
      crawlSourceScheduleNextRun: 'Next: {{time}}',
      crawlSourceScheduleEnded: 'Ended',
      crawlSourceWeekday0: 'Monday',
      crawlSourceWeekday1: 'Tuesday',
      crawlSourceWeekday2: 'Wednesday',
      crawlSourceWeekday3: 'Thursday',
      crawlSourceWeekday4: 'Friday',
      crawlSourceWeekday5: 'Saturday',
      crawlSourceWeekday6: 'Sunday',
      testingDescription:
        'Conduct a retrieval test to check if Buddy CMS can recover the intended content for the LLM.',
      similarityThreshold: 'Similarity threshold',
      similarityThresholdTip:
        'Buddy CMS employs either a combination of weighted keyword similarity and weighted vector cosine similarity, or a combination of weighted keyword similarity and weighted reranking score during retrieval. This parameter sets the threshold for similarities between the user query and chunks. Any chunk with a similarity score below this threshold will be excluded from the results.',
      vectorSimilarityWeight: 'Keywords similarity weight',
      vectorSimilarityWeightTip:
        'Sets the ratio between keyword search and semantic search. A value of 1 means searches are performed exclusively based on keywords; a value of 0 means searches are performed exclusively using semantic (vector-based) methods. Values in between combine both methods—the sum of both weights must always equal 1.0.',
      testText: 'Test text',
      testTextPlaceholder: 'Input your question here!',
      testingLabel: 'Testing',
      similarity: 'Hybrid similarity',
      termSimilarity: 'Term similarity',
      vectorSimilarity: 'Vector similarity',
      hits: 'Hits',
      view: 'View',
      filesSelected: 'Files selected',
      upload: 'Upload',
      run: 'Parse',
      runningStatus0: 'UNParsed',
      runningStatus1: 'Parsing',
      runningStatus2: 'CANCEL',
      runningStatus3: 'SUCCESS',
      runningStatus4: 'FAIL',
      pageRanges: 'Page Ranges',
      pageRangesTip:
        'Range of pages to be parsed; pages outside this range will not be processed.',
      fromPlaceholder: 'from',
      fromMessage: 'Missing start page number',
      toPlaceholder: 'to',
      toMessage: 'Missing end page number (excluded)',
      layoutRecognize: 'Layout recognition',
      layoutRecognizeTip:
        'Use visual models for layout analysis to better understand the structure of the document and effectively locate document titles, text blocks, images, and tables. If disabled, only the plain text in the PDF will be retrieved.',
      taskPageSize: 'Task page size',
      taskPageSizeMessage: 'Please input your task page size!',
      taskPageSizeTip: `During layout recognition, a PDF file is split into chunks and processed in parallel to increase processing speed. This parameter sets the size of each chunk. A larger chunk size reduces the likelihood of splitting continuous text between pages.`,
      addPage: 'Add page',
      greaterThan: 'The current value must be greater than to!',
      greaterThanPrevious:
        'The current value must be greater than the previous to!',
      selectFiles: 'Select files',
      changeSpecificCategory: 'Change specific category',
      uploadTitle: 'Click or drag file to this area to upload',
      uploadDescription:
        'Support for a single or bulk upload. Strictly prohibited from uploading company data or other banned files.',
      chunk: 'Chunk',
      bulk: 'Bulk',
      cancel: 'Cancel',
      rerankModel: 'Rerank model',
      rerankPlaceholder: 'Please select',
      rerankTip: `If left empty, Buddy CMS will use a combination of weighted keyword similarity and weighted vector cosine similarity; if a rerank model is selected, a weighted reranking score will replace the weighted vector cosine similarity.`,
      topK: 'Top-K',
      topKTip: `K chunks will be fed into rerank models.`,
      delimiter: `Delimiter`,
      delimiterTip:
        'A delimiter or separator can consist of one or multiple special characters. If it is multiple characters, ensure they are enclosed in backticks( ``). For example, if you configure your delimiters like this: \n`##`;, then your texts will be separated at line breaks, double hash symbols (##), or semicolons.',
      html4excel: 'Excel to HTML',
      html4excelTip: `When enabled, the spreadsheet will be parsed into HTML tables, and at most 256 rows for one table. Otherwise, it will be parsed into key-value pairs by row.`,
      autoKeywords: 'Auto-keyword',
      autoKeywordsTip: `Automatically extract N keywords for each chunk to increase their ranking for queries containing those keywords. You can check or update the added keywords for a chunk from the chunk list. Be aware that extra tokens will be consumed by the LLM specified in 'System model settings'.`,
      autoQuestions: 'Auto-question',
      autoQuestionsTip: `Automatically extract N questions for each chunk to increase their ranking for queries containing those questions. You can check or update the added questions for a chunk from the chunk list. This feature will not disrupt the chunking process if an error occurs, except that it may add an empty result to the original chunk. Be aware that extra tokens will be consumed by the LLM specified in 'System model settings'.`,
      redo: 'Do you want to clear the existing {{chunkNum}} chunks?',
      username: 'Username',
      passowrd: 'Password',
      rowItemsSelected: 'files selected',
      selectAllRows: 'Select all files',
      selectAllMatchingRows: 'Select all matching files',
      clearFilters: 'Clear filters',
      unselectAllRows: 'Unselect all files',
      tag: 'Tag',
      authentication: 'Authentication',
      formLogin: 'Form Login',
      loginUrl: 'Login URL',
      usernameField: 'Username Field',
      passwordField: 'Password Field',
      logoutUrlPatterns: 'Logout URL Patterns',
      crawlSettings: 'Crawl-Settings',
      extendedSettings: 'Extended Settings',
      markdownGeneratorOptions: 'Markdown Generator Options',
      discoveryMode: 'Link Discovery',
      discoveryModeDeep: 'Deep Crawl (follow links)',
      discoveryModeSitemap: 'Sitemap',
      discoveryModeUrlList: 'URL List',
      sitemapUrl: 'Sitemap URL',
      sitemapUrlTooltip:
        'URL of an XML sitemap. Pages listed in it (and in any child sitemaps it references) are crawled.',
      urlList: 'URLs',
      urlListTooltip:
        'The exact set of URLs to crawl — no link-following, no sitemap fetch, no discovery of any kind. Paste multiple URLs separated by commas or newlines.',
      urlListInvalidEntry: '"{{url}}" is not a valid http(s) URL',
      urlListTooManyEntries:
        'A URL list may not contain more than {{max}} URLs',
      respectSitemapLastmod: 'Skip unchanged pages (sitemap lastmod)',
      respectSitemapLastmodTooltip:
        'On re-crawls, skip fetching a page whose sitemap <lastmod> is not newer than when it was last captured. Turn off to force a full re-crawl.',
      downloadLinkedPdfs: 'Download linked PDFs',
      downloadLinkedPdfsTooltip:
        'Also download PDFs linked from the crawled pages, not just the URLs listed in the sitemap. Other links are not followed.',
      includeExternalRedirectTargets: 'Include external redirect targets',
      includeExternalRedirectTargetsTooltip:
        'Only relevant when "Exclude External Links" is on. A link that looks internal can still redirect to a different domain when fetched; further link discovery from that page is always blocked once it lands outside this domain. This only controls whether the redirected-to page itself is still captured as a document.',
      max_depth: {
        minimum_message: 'The maximum depth must be greater than or equal to 0',
        placeholder: 'e.g. 10',
      },
      max_pages: {
        minimum_message: 'The maximum number of pages must be greater than 0',
        placeholder: 'e.g. 10000',
      },
    },
    knowledgeConfiguration: {
      titleDescription:
        'Update your knowledge base configuration here, particularly the chunk method.',
      name: 'Knowledge base name',
      photo: 'Knowledge base photo',
      description: 'Description',
      language: 'Language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'Please input your language!',
      permissions: 'Permissions',
      embeddingModel: 'Embedding model',
      chunkTokenNumber: 'Chunk token number',
      chunkTokenNumberMessage: 'Chunk token number is required',
      embeddingModelTip:
        'The model that converts chunks into embeddings. It cannot be changed once the knowledge base has chunks. To switch to a different embedding model, you must delete all existing chunks in the knowledge base.',
      permissionsTip:
        "If set to 'Team', all team members will be able to manage the knowledge base.",
      chunkTokenNumberTip:
        'It sets the token threshold for a chunk. A paragraph with fewer tokens than this threshold will be combined with the following paragraph until the token count exceeds the threshold, at which point a chunk is created.',
      chunkMethod: 'Chunk method',
      chunkMethodTip: 'View the tips on the right.',
      replaceSameDocName: 'Replace documents with same name',
      replaceSameDocNameTip:
        'When uploading a document, if one with the same name already exists, it will be replaced by the new one.',
      imageDescription: 'Analyze images',
      imageDescriptionTip:
        'Describe images with a vision model before chunking. Applies to images and charts in PDFs as well as images in crawled web pages. Changes only affect documents parsed from now on.',
      imageDescriptionPrompt: 'Image description prompt',
      imageDescriptionPromptTip:
        'Leave empty to use the default prompt. The instruction to answer with the "no essential information" phrase is always appended, so uninformative images keep getting dropped.',
      // Keep in sync with DEFAULT_IMAGE_DESCRIPTION_PROMPT in rag/llm/cv_model.py.
      imageDescriptionPromptPlaceholder: `Beurteile, ob das folgende Bild wesentliche, interpretierbare Informationen enthält.
Fasse die wichtigsten Punkte auf Deutsch zusammen, wenn das Bild detaillierte Daten oder klare Zusammenhänge darstellt.
Du musst keinen einleitenden Text schreiben, wenn das Bild wesentliche Informationen beinhaltet, sondern starte in deiner Antwort direkt mit dem Inhalt.`,
      imageDescriptionNoModelWarning:
        'No img2txt model is configured in the system model settings. Images will not be described until one is set.',
      imageDescriptionNoModelLink: 'Open model settings',
      imageDescriptionContextBefore: 'Context before the image (characters)',
      imageDescriptionContextAfter: 'Context after the image (characters)',
      imageDescriptionContextTip:
        'How much of the surrounding document text is sent to the vision model as context. 0 disables it.',
      upload: 'Upload',
      english: 'English',
      chinese: 'Chinese',
      embeddingModelPlaceholder: 'Please select a embedding model',
      chunkMethodPlaceholder: 'Please select a chunk method',
      save: 'Save',
      me: 'Only me',
      team: 'Team',
      cancel: 'Cancel',
      methodTitle: 'Chunk method description',
      methodExamples: 'Examples',
      methodExamplesDescription:
        'The following screenshots are provided for clarity.',
      dialogueExamplesTitle: 'Dialogue examples',
      methodEmpty:
        'This will display a visual explanation of the knowledge base categories',
      book: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      For each book in PDF, please set the <i>page ranges</i> to remove unwanted information and reduce analysis time.</p>`,
      laws: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Legal documents typically follow a rigorous writing format. We use text feature to identify split point. 
      </p><p>
      The chunk has a granularity consistent with 'ARTICLE', ensuring all upper level text is included in the chunk.
      </p>`,
      manual: `<p>Only <b>PDF</b> is supported.</p><p>
      We assume that the manual has a hierarchical section structure, using the lowest section titles as basic unit for chunking documents. Therefore, figures and tables in the same section will not be separated, which may result in larger chunk sizes.
      </p>`,
      naive: `<p>Supported file formats are <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML, HTML</b>.</p>
      <p>This method chunks files using a 'naive' method: </p>
      <p>
      <li>Use vision detection model to split the texts into smaller segments.</li>
      <li>Then, combine adjacent segments until the token count exceeds the threshold specified by 'Chunk token number', at which point a chunk is created.</li></p>`,
      paper: `<p>Only <b>PDF</b> file is supported.</p><p>
      Papers will be split by section, such as <i>abstract, 1.1, 1.2</i>. </p><p>
      This approach enables the LLM to summarize the paper more effectively and to provide more comprehensive, understandable responses. 
      However, it also increases the context for AI conversations and adds to the computational cost for the LLM. So during a conversation, consider reducing the value of ‘<b>topN</b>’.</p>`,
      presentation: `<p>Supported file formats are <b>PDF</b>, <b>PPTX</b>.</p><p>
      Every page in the slides is treated as a chunk, with its thumbnail image stored.</p><p>
      <i>This chunk method is automatically applied to all uploaded PPT files, so you do not need to specify it manually.</i></p>`,
      qa: `
      <p>
      This chunk method supports <b>EXCEL</b> and <b>CSV/TXT</b> file formats.
    </p>
    <li>
      If a file is in <b>Excel</b> format, it should contain two columns
      without headers: one for questions and the other for answers, with the
      question column preceding the answer column. Multiple sheets are
      acceptable, provided the columns are properly structured.
    </li>
    <li>
      If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate questions and answers.
    </li>
    <p>
      <i>
        Lines of texts that fail to follow the above rules will be ignored, and
        each Q&A pair will be considered a distinct chunk.
      </i>
    </p>
      `,
      resume: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      </p><p>
      Résumés of various forms are parsed and organized into structured data to facilitate candidate search for recruiters.
      </p>
      `,
      table: `<p>Supported file formats are <b>EXCEL</b> and <b>CSV/TXT</b>.</p><p>
      Here're some prerequisites and tips:
      <ul>
    <li>For CSV or TXT file, the delimiter between columns must be <em><b>TAB</b></em>.</li>
    <li>The first row must be column headers.</li>
    <li>Column headers must be meaningful terms to aid your LLM's understanding.
    It is good practice to juxtapose synonyms separated by a slash <i>'/'</i> and to enumerate values using brackets, for example: <i>'Gender/Sex (male, female)'</i>.<p>
    Here are some examples of headers:<ol>
        <li>supplier/vendor<b>'TAB'</b>Color (Yellow, Blue, Brown)<b>'TAB'</b>Sex/Gender (male, female)<b>'TAB'</b>size (M, L, XL, XXL)</li>
        </ol>
        </p>
    </li>
    <li>Every row in table will be treated as a chunk.</li>
    </ul>`,
      picture: `
    <p>Image files are supported, with video support coming soon.</p><p>
    This method employs an OCR model to extract texts from images.
    </p><p>
    If the text extracted by the OCR model is deemed insufficient, a specified visual LLM will be used to provide a description of the image.
    </p>`,
      one: `
    <p>Supported file formats are <b>DOCX, EXCEL, PDF, TXT</b>.
    </p><p>
    This method treats each document in its entirety as a chunk.
    </p><p>
    Applicable when you require the LLM to summarize the entire document, provided it can handle that amount of context length.
    </p>`,
      knowledgeGraph: `<p>Supported file formats are <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>

<p>This approach chunks files using the 'naive'/'General' method. It splits a document into segments and then combines adjacent segments until the token count exceeds the threshold specified by 'Chunk token number', at which point a chunk is created.</p>
<p>The chunks are then fed to the LLM to extract entities and relationships for a knowledge graph and a mind map.</p>
<p>Ensure that you set the <b>Entity types</b>.</p>`,
      tag: `<p>Knowlege base using 'Tag' as a chunking method is supposed to be used by other knowledge bases to add tags to their chunks, queries to which will also be with tags too.</p>
<p>Knowlege base using 'Tag' as a chunking method is <b>NOT</b> supposed to be involved in RAG procedure.</p>
<p>The chunks in this knowledge base are examples of tags, which demonstrate the entire tag set and the relevance between chunk and tags.</p>

<p>This chunk method supports <b>EXCEL</b> and <b>CSV/TXT</b> file formats.</p>
<p>If a file is in <b>Excel</b> format, it should contain two columns without headers: one for content and the other for tags, with the content column preceding the tags column. Multiple sheets are acceptable, provided the columns are properly structured.</p>
<p>If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate content and tags.</p>
<p>In tags column, there're English <b>comma</b> between tags.</p>
<i>Lines of texts that fail to follow the above rules will be ignored, and each  pair will be considered a distinct chunk.</i>
`,
      useRaptor: 'Use RAPTOR to enhance retrieval',
      useRaptorTip:
        'Recursive Abstractive Processing for Tree-Organized Retrieval, see https://huggingface.co/papers/2401.18059 for more information.',
      prompt: 'Prompt',
      promptTip: 'LLM prompt used for summarization.',
      promptMessage: 'Prompt is required',
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
      {cluster_content}
The above is the content you need to summarize.`,
      maxToken: 'Max token',
      maxTokenTip: 'Maximum token number for summarization.',
      maxTokenMessage: 'Max token is required',
      threshold: 'Threshold',
      thresholdTip: 'The bigger the threshold is the less cluster will be.',
      thresholdMessage: 'Threshold is required',
      maxCluster: 'Max cluster',
      maxClusterTip: 'Maximum cluster number.',
      maxClusterMessage: 'Max cluster is required',
      randomSeed: 'Random seed',
      randomSeedMessage: 'Random seed is required',
      entityTypes: 'Entity types',
      vietnamese: 'Vietnamese',
      pageRank: 'Page rank',
      pageRankTip: `This increases the relevance score of the knowledge base. Its value will be added to the relevance score of all retrieved chunks from this knowledge base. Useful when you are searching within multiple knowledge bases and wanting to assign a higher pagerank score to a specific one.`,
      tagName: 'Tag',
      frequency: 'Frequency',
      searchTags: 'Search tags',
      tagCloud: 'Cloud',
      tagTable: 'Table',
      tagSet: 'Tag set',
      tagSetTip: `
     <p> Selecting the 'Tag' knowledge bases helps to tag every chunks. </p>
<p>Query to those chunks will also be with tags too.</p>
This procedure will improve precision of retrieval by adding more information to the dataset, especially when there's a large set of chunks.
<p>Difference between tags and keywords:</p>
<ul>
  <li>Tag is a close set which is defined and manipulated by user while keyword is an open set.</li>
  <li>You need to upload tag sets with samples prior to use.</li>
  <li>Keywords are generated by LLM which is expensive and time consuming.</li>
</ul>
      `,
      topnTags: 'Top-N Tags',
    },
    chunk: {
      chunk: 'Chunk',
      bulk: 'Bulk',
      selectAll: 'Select All',
      enabledSelected: 'Enable selected',
      disabledSelected: 'Disable selected',
      deleteSelected: 'Delete selected',
      search: 'Search',
      all: 'All',
      enabled: 'Enabled',
      disabled: 'Disabled',
      keyword: 'Keyword',
      function: 'Function',
      chunkMessage: 'Please input value!',
      full: 'Full text',
      ellipse: 'Ellipse',
      graph: 'Knowledge graph',
      mind: 'Mind map',
      question: 'Question',
      questionTip: `If there're given questions, the embedding of the chunk will be based on them.`,
    },
    memberInvites: {
      back: 'Back',
      landingTitle: 'Invitation to a buddy',
      landingBody:
        'This invitation is redeemed in the Buddy app and is valid for one device only.',
      landingOpen: 'Open in the Buddy app',
      landingHelp:
        "Nothing happens? Install the Buddy app from the App Store or Google Play, then open this link again — or scan the invitation's QR code in the app.",
      landingInvalid:
        'This invitation link is incomplete. Please open the link exactly as you received it.',
      menuEntry: 'App members',
      title: 'App members & invitations',
      inviteMember: 'Invite new member',
      featureOffTitle: 'App invitations are switched off',
      featureOffDescription:
        'Switch on "App invitations" in this buddy\'s settings to send new invitations. Existing members cannot use the buddy while it is off.',
      tabMembers: 'Members',
      tabInvites: 'Invitations',
      label: 'Name / note',
      labelTip:
        'Who the invitation is for, so you can tell members apart. Only visible to you, never to the member.',
      labelPlaceholder: 'e.g. Ms Miller, physio group A',
      unnamed: '(no name)',
      createTitle: 'Invite a new member',
      create: 'Create invitation link',
      status: 'Status',
      status_active: 'Active',
      status_revoked: 'Revoked',
      status_open: 'Open',
      status_redeemed: 'Redeemed',
      status_expired: 'Expired',
      revokedOn: 'Revoked on {{date}}',
      devices: 'Devices',
      deviceCount: '{{active}} active',
      device: 'Device',
      platform_android: 'Android',
      platform_ios: 'iOS',
      attestation: 'Key storage',
      attestation_STRONGBOX: 'StrongBox',
      attestation_TEE: 'Secure hardware',
      attestation_SECURE_ENCLAVE: 'Secure Enclave',
      attestation_SOFTWARE: 'Unverified',
      attestationSoftwareTip:
        'This device could not prove that its key is stored in secure hardware. It was only accepted because the server runs in test mode.',
      enrolled: 'Registered',
      lastSeen: 'Last access',
      never: 'never',
      created: 'Created',
      expiresAt: 'Valid until',
      kind: 'Type',
      kind_new_member: 'New member',
      kind_add_device: 'Additional device for {{label}}',
      addDevice: 'Add device',
      revokeAccess: 'Revoke access',
      deleteMember: 'Delete',
      revokeDevice: 'Remove device',
      revokeInvite: 'Withdraw',
      revokeMemberConfirmTitle: 'Revoke access for {{label}}?',
      revokeMemberConfirmContent:
        'All devices of this member lose access immediately, and their open invitations are withdrawn. Their chat history is kept, and you can bring them back later with a new device invitation.',
      deleteMemberConfirmTitle: 'Delete {{label}} permanently?',
      deleteMemberConfirmContent:
        'The member, their devices, all their conversations with this buddy and the documents they uploaded are deleted. This cannot be undone.',
      revokeDeviceConfirmTitle: 'Remove {{device}}?',
      revokeDeviceConfirmContent:
        'The device loses access immediately. The member keeps their other devices and their chat history.',
      revokeInviteConfirmTitle: 'Withdraw this invitation?',
      revokeInviteConfirmContent: 'The link stops working immediately.',
      revealTitle: 'Invitation for {{label}}',
      revealDeviceTitle: 'Additional device for {{label}}',
      revealOnce: 'Copy or share this link now',
      revealOnceDescription:
        'For security reasons the link is shown only once. It is valid until {{date}} and can be redeemed exactly once, on one device. If it gets lost, withdraw it and create a new one.',
      revealLink: 'Invitation link',
      revealQr: 'Scan with the Buddy app or the phone camera',
      revealDone: 'Done',
      emptyMembers: 'No members yet. Invite someone to get started.',
      emptyInvites: 'No invitations yet.',
      featureDisabled:
        'App invitations are switched off for this buddy. Switch them on in its settings first.',
      deviceLimitReached:
        'This member has reached the maximum number of devices (open invitations included). Remove a device or withdraw an open invitation first.',
      memberNotFound: 'This member no longer exists.',
      deviceNotFound: 'This device no longer exists.',
      inviteNotFound: 'This invitation no longer exists.',
    },
    chat: {
      recencyBoost: 'Prefer recent documents',
      recencyBoostTip:
        'Favours documents with a more recent publication year when ranking search results. Only affects documents that have a publication year set; documents without one are never pushed down. Useful when a knowledge base holds several editions of the same guideline.',
      recencyBoostOff: 'Off',
      recencyBoostLight: 'Light',
      recencyBoostStrong: 'Strong',
      // Progress of an agentic answer, shown while it is being produced.
      agentStepsLabel: 'Progress',
      agentStepThinking: 'Thinking…',
      agentStepThinkingDone: 'Thought it through',
      agentStepTool: 'Using a tool…',
      agentStepToolDone: 'Used a tool',
      agentStepConsulting: 'Consulting {{name}}…',
      agentStepConsultingDone: 'Consulted {{name}}',
      agentStepSearching: 'Searching the knowledge base…',
      agentStepSearchingDone: 'Searched the knowledge base',
      agentStepSearchingDoneCount_one:
        'Searched the knowledge base · {{count}} relevant passage found',
      agentStepSearchingDoneCount_other:
        'Searched the knowledge base · {{count}} relevant passages found',
      agentStepWebsearch: 'Searching the web…',
      agentStepWebsearchDone: 'Searched the web',
      agentStepBrowsing: 'Looking through the documents…',
      agentStepBrowsingDone: 'Looked through the documents',
      agentStepReading: 'Reading a document…',
      agentStepReadingDone: 'Read the document',
      agentStepFailed:
        'A step did not work — continuing with what is available',
      formValidationError: 'Please check the form for errors and try again.',
      newConversation: 'New conversation',
      createAssistant: 'Create an Assistant',
      exportEvaluation: {
        title: 'Export Chat History',
        description:
          'Export your chat histories to a file. Includes all messages sent by users, chatbot responses, and user feedback.',
        downloadError: 'Export failed: {{error}}',
        preparing: 'Preparing the export, the download will start shortly …',
        ready: 'Export finished – the file is in your downloads.',
        failed: 'The export failed. Please try again.',
        busy: 'Too many exports are running right now. Please try again in a few minutes.',
        cancelled: 'You cancelled the export.',
        disconnected: 'The connection was lost and the export stopped.',
        restart: 'Restart',
        cancel: 'Cancel export',
        toastTitle: 'Creating {{format}} export',
        finishing: 'Finishing the file …',
        otherExportRunning:
          'An export of another chatbot is running. Wait for it to finish or cancel it.',
        alreadyRunning: 'An export of this chatbot is already running.',
        progress: '{{done}} of {{total}} sessions processed',
        csv: 'Download CSV',
        xlsx: 'Download XLSX',
        runningHint:
          'You can close this window or leave the page – the download continues in your browser, and its progress stays visible in the corner.',
        filterDateRange: 'Filter by Date Range',
      },
      assistantSetting: 'Assistant Setting',
      pleaseSetSttModel:
        'Please set Speech2txt model firstly. Setting >> Model Providers >> System Model Settings',
      pleaseSetTtsModel:
        'Please set TTS model firstly. Setting >> Model Providers >> System Model Settings',
      pleaseSetDiarizationModel:
        'Please set a Diarization model firstly. Setting >> Model Providers >> System Model Settings',
      designSetting: 'Design Setting',
      contentSetting: 'Content Setting',
      promptEngine: 'Prompt Engine',
      modelSetting: 'Model Setting',
      chat: 'Chat',
      newChat: 'New chat',
      send: 'Send',
      sendPlaceholder: 'Your Question...',
      footerDisclaimer: 'Buddy can make mistakes. Use at your own risk.',
      languageSelectTitle: 'Select language',
      chatConfiguration: 'Chat Configuration',
      chatConfigurationDescription:
        ' Set up a chat assistant dedicated to your selected knowledge bases here!',
      general: 'Identity',
      assistantName: 'Assistant name',
      assistantNameMessage: 'Assistant name is required',
      namePlaceholder: 'e.g. Resume Jarvis',
      descriptionPlaceholder:
        'e.g. explains content from the health knowledge base',
      assistantAvatar: 'Assistant avatar',
      interaction: 'Interaction',
      language: 'Language',
      languageTip: 'Main language of the chat assistant.',
      languageSelection: 'Enable language selection',
      languageSelectionTip:
        'Allow users to select the language during the chat.',
      autofocusInput: 'Focus input on open',
      autofocusInputTip:
        'Place the cursor in the message input when the chat is opened, so users can type right away. Turn this off to avoid the on-screen keyboard opening on mobile devices.',
      emptyResponse: 'Empty response',
      emptyResponseTip: `Set this as a response if no results are retrieved from the knowledge bases for your query, or leave this field blank to allow the LLM to improvise when nothing is found.`,
      enableOpener: 'Enable opening greeting',
      enableOpenerTip:
        'Decide whether to show a greeting message when the chat is initiated.',
      setAnOpener: 'Opening greeting',
      setAnOpenerInitial: `Hi! I'm your assistant, what can I do for you?`,
      setAnOpenerTip: 'Set an opening greeting for users.',
      showSuggestedQuestions: 'Show suggested questions',
      showSuggestedQuestionsTip:
        'Enable to display suggested questions based on the knowledge base content.',
      showSuggestedQuestionsOnStartup: 'Show on startup',
      showSuggestedQuestionsOnStartupTip:
        'Enable to display suggested questions when the chat interface is first loaded.',
      misc: 'Miscellaneous',
      citation: 'Citation',
      restrictAccess: 'Restrict access',
      restrictAccessTip:
        'Restrict access to this chat assistant to specific IP addresses or users.',
      userAuthentication: 'User authentication',
      userAuthenticationTip:
        'Require requests to present a token signed by the corresponding private key; tokens will be verified using the configured public key.',
      deviceInvites: 'App invitations',
      deviceInvitesTip:
        'Invite individual people to use this buddy in the Buddy app with a one-time link. Each person gets access on their own device only; the access cannot be copied to another device.',
      deviceInvitesHint:
        'After saving, manage members and invitation links via this buddy\'s ⋯ menu → "App members". App members are not subject to the IP restriction.',
      allowedIps: 'Allowed IPs',
      allowedIpsTip:
        'Specify the IP addresses that are allowed to access this chat assistant. Leave this field empty to allow access from all IP addresses.',
      invalidIp: 'Invalid IP format',
      allowedIpsPlaceholder: 'e.g. 192.168.1.1',
      publicKey: 'Public Key',
      publicKeyTip:
        'Define a public key that can be used to authenticate tokens from users of your system. To do this, your system must be able to generate tokens with the corresponding private key.',
      privateKey: 'Private Key',
      showChatHistory: 'Show Chat History',
      showChatHistoryTooltip:
        'Allows the user to show the history of his previous chats in a sidebar.',
      showChatHistoryNeedsSaving:
        'Requires saved conversations. Switch "Save conversations" back on to use the history sidebar.',
      saveConversations: 'Save conversations',
      saveConversationsTip:
        'Store the conversations of this chatbot. When switched off, a conversation only exists while it is being talked to and is never written to the database: no chat history sidebar, no feedback buttons, no data on the evaluation page, and nothing to export. Existing conversations are kept.',
      generateKeyPair: 'Generate new key pair',
      publicKeyRequired: 'Public key is required',
      generateKeyPairDescription:
        'Do you want to generate a new Keypair?\nThe private key will only be displayed once.\nSo make sure to save it somewhere secure and keep it secret.',
      copyPrivateKey: 'Copy',
      reportingEnabled: 'Enable reporting',
      reportingEnabledTip:
        'Enable weekly reporting about your Buddy metrics via email',
      reportingEmailAddresses: 'Email addresses',
      reportingEmailAddressesTip:
        'Enter the email addresses to which the report should be sent.',
      reportingEmailAddressesPlaceholder: 'e.g. peter@lustig.de',
      reportingCycle: 'Reporting cycle',
      reportingCycleTip:
        'Specify the frequency at which reports are generated and sent.',
      weekly: 'Weekly',
      monthly: 'Monthly',
      showDisclaimer: 'Show disclaimer',
      showDisclaimerTip:
        'Enable to display a disclaimer at the first time of the chat interface use.',
      disclaimerTitle: 'Disclaimer title',
      disclaimerTitleTip: 'Set the title of the disclaimer.',
      disclaimerText: 'Disclaimer text',
      disclaimerTextTip:
        'Specify the content that should be displayed in the disclaimer.',
      positiveFeedbackTitle: 'Positive feedback title',
      positiveFeedbackTitleTip: 'Set the title and text for positive feedback.',
      positiveFeedbackText: 'Positive feedback text',
      positiveFeedbackTextTip:
        'Specify the text that should be displayed in the positive feedback.',
      positiveFeedbackDefaultTitle: 'Send feedback',
      positiveFeedbackDefaultText:
        'Thank you for your feedback! You can optionally leave us a comment as well.',
      negativeFeedbackTitle: 'Negative feedback title',
      negativeFeedbackTitleTip: 'Set the title for negative feedback.',
      negativeFeedbackText: 'Negative feedback text',
      negativeFeedbackTextTip:
        'Specify the text that should be displayed in the negative feedback.',
      negativeFeedbackDefaultTitle: 'Report a problem',
      negativeFeedbackDefaultText:
        'The answer is not okay? Please indicate what type of problem it is. We will then review this chat session in anonymised form.',
      design: 'Design',
      themeTypography: 'Theme & typography',
      backgroundColor: 'Chat Background Color',
      backgroundColorTip:
        'Choose the background color that the chat should have.',
      fontFamily: 'Chat font family',
      fontFamilyTip: 'Choose the font family that the chat should use.',
      fontSize: 'Chat font size',
      fontSizeTip: 'Choose the font size that the chat should use.',
      messageArea: 'Message area',
      enableAutoscroll: 'Enable autoscroll',
      enableAutoscrollTip:
        'Enable scrolling down automatically to the latest messages',
      enableTextSelection: 'Enable copying text',
      enableTextSelectionTip:
        'Enable selecting and copying the text of messages',
      assistantBubble: 'Buddy',
      userBubble: 'User',
      msgBubbleColorUser: 'Message color user',
      msgBubbleColorUserTip:
        'Choose the color of the messages you send as a user',
      msgBubbleColorBuddy: 'Message color buddy',
      msgBubbleColorBuddyTip:
        'Choose the color of the messages that Buddy sends you',
      textColorUser: 'User text color',
      textColorUserTip:
        'Choose the color of the text of the messages you send as a user',
      textColorBuddy: 'Buddy text color',
      textColorBuddyTip:
        'Choose the color of the text of the messages that Buddy sends you',
      msgBubbleBorderUser: 'Border messages user',
      msgBubbleBorderUserTip:
        'Choose whether the messages you send as a user should have a border.',
      msgBubbleBorderColorUser: 'Border color messages user',
      msgBubbleBorderColorUserTip:
        'Choose the border color of the messages you send as a user',
      msgBubbleBorderBuddy: 'Border messages buddy',
      msgBubbleBorderBuddyTip:
        'Choose whether the messages Buddy sends you should have a border.',
      msgBubbleBorderColorBuddy: 'Border color messages buddy',
      msgBubbleBorderColorBuddyTip:
        'Choose the border color of the messages that Buddy sends you',
      references: 'References',
      referenceTextColor: 'Reference text color',
      referenceTextColorTip:
        'Set the color of the text of references in Buddy messages',
      referenceTextColorHover: 'Reference text color (hover)',
      referenceTextColorHoverTip:
        'Set the color of the reference text in Buddy messages when the mouse hovers over it.',
      buttonsReactions: 'Buttons & reactions',
      primaryButtons: 'Chat buttons',
      buttonColor: 'Chat button color',
      buttonColorTip: 'Choose the color of the buttons in the chat',
      buttonTextColor: 'Text color',
      buttonTextColorHover: 'Text color (hover)',
      buttonTextColorHoverTip:
        'Choose the text color of the buttons in the chat when the mouse hovers over them.',
      reactionButtons: 'Reaction buttons',
      reactionButtonColor: 'Button',
      reactionButtonTextColor: 'Text',
      reactionButtonColorTip:
        'Choose the color of the reaction buttons in the chat',
      reactionButtonColorHover: 'Button hover',
      reactionButtonColorHoverTip:
        'Choose the color of the reaction buttons in the chat when the mouse hovers over them.',
      reactionButtonTextColorHover: 'Text hover',
      reactionButtonTextColorHoverTip:
        'Choose the text color of the reaction buttons in the chat when the mouse hovers over them.',
      reactionButtonColorActive: 'Button active',
      reactionButtonColorActiveTip:
        'Choose the color of the active reaction buttons in the chat.',
      reactionButtonTextColorActive: 'Text active',
      reactionButtonTextColorActiveTip:
        'Choose the text color of the active reaction buttons in the chat.',
      inputField: 'Input field',
      inputColor: 'Input field color',
      inputColorTip:
        'Choose the color of the input field for sending messages.',
      inputTextColor: 'Input field text color',
      inputTextColorTip:
        'Choose the color of the text in the input field for sending messages.',
      inputPlaceholderText: 'Text Input Placeholder',
      inputPlaceholderTextTip:
        'Specify the text of the placeholder that is displayed in the input field for sending messages.',
      footer: 'Footer',
      footerText: 'Footer text',
      footerTextTip:
        'Specify the text to be displayed in the footer below the input field. Markdown syntax is supported.',
      footerColor: 'Footer text color',
      footerColorTip: 'Choose the color of the footer below the input field.',
      footerTextDefault:
        'Buddy can make mistakes. Use at your own risk. [Innovative Health by ZTM](https://www.ztm.de/buddy).',
      knowledge: 'Knowledge',
      knowledgeBases: 'Knowledge bases',
      knowledgeBasesMessage: 'Please select',
      knowledgeBasesTip:
        'Optional. Select the knowledge bases to associate with this chat assistant. Leave empty and the assistant answers from its system prompt and the conversation alone — remove the {knowledge} variable from the system prompt in that case.',
      documentUpload: 'Document upload in chat',
      documentUploadTip:
        'Let chat users upload documents into their conversation and choose which of them the assistant may use for each question. Uploads are stored separately from your knowledge bases and are deleted automatically a while after upload.',
      documentUploadTitle: 'Documents in this conversation',
      chatUploadRetention: 'Keep uploaded documents',
      chatUploadRetentionTip:
        'How long a document stays available after it was uploaded. Each document expires on its own clock, counted from its upload. Changing this applies to conversations started afterwards; ones already under way keep the retention they began with.',
      chatUploadRetentionNeedsHistory:
        'A longer retention needs chat history, so the conversation can be reopened to use the documents again. Switch it on under Assistant Setting — it also requires saved conversations and either user authentication or app invitations.',
      chatUploadRetentionDefault: 'Default',
      chatUploadRetentionNotOffered:
        'This deployment keeps uploaded documents for a fixed period, so there is nothing to choose here.',
      chatUploadRetentionDays: '{{days}} days',
      documentUploadAction: 'Upload document',
      documentUploadEmpty: 'No documents uploaded yet.',
      documentUploadAnalysing: 'Analysing…',
      documentUploadQueued: 'Waiting for a free analysis slot…',
      documentUploadFailed: 'Analysis failed',
      documentUploadReady: 'Ready',
      documentUploadRemove: 'Remove document',
      documentUploadTooLarge:
        'This file is larger than the {{size}} MB upload limit.',
      documentUploadTooManyPages:
        'This PDF has {{pages}} pages. Up to {{max}} pages can be analysed.',
      documentUploadLimitReached:
        'This conversation already holds the maximum of {{limit}} documents.',
      documentUploadUnsupportedType: 'This type of file is not supported.',
      documentUploadEmptyFile: 'This file is empty.',
      documentUploadNoFile: 'No file was uploaded.',
      documentUploadNoContent:
        'No text could be extracted from this document, so the assistant cannot use it.',
      documentUploadTransportFailed:
        'The file could not be uploaded. Please check your connection and try again.',
      documentUploadHasErrors:
        'Some documents could not be analysed. Open the list for details.',
      documentUploadSourceExpired: 'Source no longer available',
      documentTools: 'Reading documents',
      documentToolsTip:
        'How the assistant reads one document in depth. "Relevant excerpts" fetches the passages of the document that best match a query. "Navigation" reads the document in its original order — by table of contents, section or page — and can summarise long documents. Use an evaluation to compare the two before switching. Requires tool usage and reasoning.',
      documentTools_legacy: 'Relevant excerpts (default)',
      documentTools_navigation: 'Navigation by section and page (new)',
      spreadsheetAnalysis: 'Excel analysis',
      spreadsheetAnalysisTip:
        'Lets the assistant calculate exact figures — sums, averages, counts, rankings — from Excel workbooks (.xlsx, .xlsm) in the knowledge bases and from workbooks users attach to a question. It reads the workbook itself rather than the text excerpts search returns. Requires tool usage and reasoning.',
      spreadsheetAnalysisStrategy: 'Analysis method',
      spreadsheetAnalysisStrategyTip:
        'How the assistant works with a workbook. Leave empty to use the default of this installation; choosing one explicitly lets you compare methods with an evaluation.',
      spreadsheetAnalysisStrategyDefault: 'Default of this installation',
      spreadsheetAnalysisStrategy_sql: 'SQL queries',
      webSearch: 'Web Search',
      webSearchTip:
        'Enable this option so that the assistant performs a live web search for questions not covered by the knowledge bases. Web pages are not searched in their entirety—instead, the assistant retrieves the preview texts (snippets) that the selected search engine (default: Brave) returns for the respective query from the allowed domains.',
      webSearchProvider: 'Search Provider',
      webSearchProviderTip:
        'Automatic uses the Brave Search API when this installation has an API key configured, and the keyless ddgs backend otherwise. Brave Search API always uses the API and returns no results if no key is configured.',
      webSearchProviderAuto: 'Automatic (Brave API if configured)',
      webSearchProviderBraveApi: 'Brave Search API',
      webSearchProviderDdgs: 'ddgs (keyless)',
      webSearchBackend: 'Backend',
      webSearchBackendTip:
        'The search engines the keyless ddgs backend queries. Has no effect when the Brave Search API is used.',
      webSearchAllowedSites: 'Web Search Allowed Sites',
      webSearchAllowedSitesTip:
        'Enter a comma-separated list of domains the assistant is allowed to use for web searches. Leave this field empty to allow all domains.',
      WebSearchPleaseSelectAtLeastOneBackend:
        'Please select at least one backend.',
      pubmedSearch: 'PubMed search',
      pubmedSearchTip:
        'Enable this option if the assistant should use PubMed search capabilities to answer questions that are not covered by the knowledge bases.',
      pubmedEmail: 'PubMed email',
      pubmedEmailInitialValue: 'email@example.com',
      pubmedEmailTip:
        'Email address required by NCBI for using the PubMed API.',
      pubmedSearchMaxResults: 'PubMed max results',
      pubmedSearchMaxResultsInitialValue: 5,
      pubmedSearchMaxResultsTip:
        'Maximum number of search results to retrieve from PubMed for each query.',
      pubmedQueryBuilder: 'PubMed query builder',
      pubmedQueryBuilderTip:
        'Your prompts or instructions for the LLM regarding the generation of PubMed search queries based on the user question and the chat history.',
      pubmedQueryBuilderInitialValue: `Your task is to generate a precise PubMed search query based on the user's question and the chat history.`,
      system: 'System',
      systemInitialValue: `You are an intelligent assistant. Please summarize the content of the knowledge base to answer the question. Please list the data in the knowledge base and answer in detail. When all knowledge base content is irrelevant to the question, your answer must include the sentence "The answer you are looking for is not found in the knowledge base!" Answers need to consider chat history.
      Today is {now}.
      Here is the knowledge base:
      {knowledge}
      The above is the knowledge base.`,
      systemMessage: 'Please input!',
      systemTip:
        'Your prompts or instructions for the LLM, including but not limited to its role, the desired length, tone, and language of its answers.',
      enterFullscreen: 'Edit fullscreen',
      exitFullscreen: 'Exit fullscreen (Esc)',
      promptRefineQuestion: 'Search Strategy Prompt',
      promptRefineQuestionTip:
        'Your prompts or instructions for the LLM regarding refining the question and considering the chat history.',
      promptRefineQuestionInitialValue: `Role: A helpful buddy

Task and Steps:  
1. Formulate the complete user question that logically follows from the previous conversation.  
2. If the user question contains relative time references (e.g., "yesterday", "next week"), convert them into absolute dates based on the current date {today}. Example: "yesterday" → {yesterday}.  
3. Ensure that medical abbreviations (e.g., "MS") are automatically expanded once, with the abbreviation in parentheses: "Multiple Sclerosis (MS)".  

Requirements & Constraints:  
- The generated text MUST be in the same language as the original user question (default is German).  
- If the last user question is already complete and unambiguous, do nothing and return the original question.  
- DO NOT generate any additional text other than the refined question.  

######################  
-Examples-  
######################  

# Example 1  
## Conversation  
USER: What are the symptoms of MS?  
ASSISTANT: Fatigue and vision problems are common.  
USER: And in older patients?  
###############  
Output: What symptoms occur in older patients with Multiple Sclerosis (MS)?  

------------  
# Example 2  
## Conversation  
USER: What side effects does Ibuprofen have?  
ASSISTANT: Stomach issues are common.  
USER: And with long-term use?  
###############  
Output: What side effects occur with long-term use of Ibuprofen?  

------------  
# Example 3  
## Conversation  
USER: What is high blood pressure?  
ASSISTANT: A condition where blood pressure is permanently elevated.  
USER: And what values apply for adults?  
###############  
Output: What blood pressure values are considered high blood pressure in adults?  

------------  
# Example 4 (with date)  
## Conversation  
USER: What preventive check-ups should be done from age 50?  
ASSISTANT: A colonoscopy is recommended.  
USER: And what if my last one was two years ago?  
###############  
Output: What preventive check-ups are recommended for a person who had their last colonoscopy on {two_years_ago} and is now 50 years old?  

######################  

# Real Data  
## Conversation  
{conv}  
##############
      `,
      promptLinkQuotes: 'Source annotation',
      promptLinkQuotesTip:
        'Your requests or instructions for the LLM regarding the linking of sources in the answers (how and where to cite, what types of sources must be specified).',
      promptLinkQuotesInitialValue: `Your task is to add chunk citations to statements in the response text only if those statements are directly and substantively supported by the provided chunks.

Goal:
Every substantively relevant statement that is materially based on information from the chunks MUST receive a citation.
No incorrect, imprecise, or speculative citations may be produced under any circumstances.

Work with extreme care and examine every single statement meticulously.
You must not make any mistakes.

Rules:

Every substantively relevant statement that materially originates from the provided chunks MUST be cited.
If such a statement cannot be cited with confidence, it must not appear as a claim supported by the chunks.
Cite every statement that could not be made in that form without the chunks.
Also cite statements that are paraphrased in the response text, as long as the chunk clearly supports the meaning of the statement.
Also take synonyms, reworded content, and semantically equivalent statements into account.
A citation may only be added if the chunk supports the statement directly, clearly, and materially.
If you are not sure whether a chunk truly supports the statement, you must not add a citation.
If multiple chunks are suitable, choose the most precise and relevant chunk.
Use only the index numbers of the chunks, starting from 0.
Do not add any additional explanations or comments.
Respond only with the revised text including the citations.
If several consecutive passages require the same citation, add the citation only once at the end of the last relevant passage.
Never add a citation merely because the topic is generally similar.
Never add a citation for general world knowledge, stylistic linking words, or purely logical transitions, unless they are based on chunk content.
If a statement is partially supported and partially unsupported, do not cite it imprecisely. In that case, only the actually supported part may receive a citation.

Important priority:
Missing citations for clearly supported statements are an error.
Incorrect or too weak citations are also an error.
Therefore, cite strictly, precisely, and comprehensively.

Examples:

If a chunk states that AOSD frequently affects the knees and wrists, then a statement such as
"Typically, the knees and wrists are primarily affected ##3$$"
may be cited.
If a chunk only mentions arthritis in general but does not name the affected joints, then the statement
"Typically, the knees and wrists are affected"
must not be cited with that chunk.
If the response text uses a phrase such as "inflamed joints" and the chunk refers to "arthritis", a citation may be added, provided the meaning is substantively equivalent.

Output format:

Only the final revised text with citations.
No meta-comments.`,
      promptSuggestedQuestions: 'Suggested Questions Prompt',
      promptSuggestedQuestionsTip:
        'Your prompts or instructions for the LLM regarding the creation of follow-up questions',
      promptSuggestedQuestionsInitialValue: `Objective: To generate questions that the user could ask and that follow on from the previous chat history between the user and chatbot in order to guide the user through the conversation.
Instructions:
- Name 2 further questions from the user's perspective that they could ask following the previous course of the conversation.
- Not formulating a question is NOT an OPTION.
- Do not use brackets or the like. The questions should ONLY contain text.
- It is important that you define questions that do not steer the course of the conversation too much in one direction, but also vary it and steer the course of the conversation back to medical and health topics.
- Don't go too deeply into a single detail, if the conversation has often gone in one direction, vary the questions.
- Do NOT translate, but use the language of the original question.
- Do not generate questions that have already been answered in the course of the conversation.
- Use the following knowledge to generate the questions so that questions are asked that can be answered by the knowledge. If no knowledge is available, generate the questions anyway.

      Knowledge: 

      {knowledge}

      End of knowledge

### Example:
Chat history:
  User: What are the most common symptoms of diabetes?
  Assistant: Common symptoms of diabetes are severe thirst, frequent urination, fatigue, weight loss, cravings, blurred vision, poorly healing wounds, infections and tingling in hands or feet.
Suggested questions:
1. how is diabetes diagnosed?
2. what treatment options are available for managing diabetes?`,
      promptGlossary: 'Glossary',
      promptGlossaryTip:
        'Glossary of terms and abbreviations to be used when answering questions.',
      promptGlossaryInitialValue: `ZTM = Zentrum für Telemedizin
MS = Multiple Sclerosis
HI = Heart insufficiency
TTS = Text to Speech
STT = Speech to Text
LLM = Large Language Model`,
      topN: 'Top N',
      topNTip: `Not all chunks with similarity score above the 'similarity threshold' will be sent to the LLM. This selects 'Top N' chunks from the retrieved ones.`,
      variable: 'Variable',
      variableTip: `Variables can assist in developing more flexible strategies, particularly when you are using our chat assistant management APIs. These variables will be used by 'System' as part of the prompts for the LLM. The variable {knowledge} is a reserved special variable representing your selected knowledge base(s), and all variables should be enclosed in curly braces {}.`,
      add: 'Add',
      key: 'Key',
      optional: 'Optional',
      operation: 'Operation',
      model: 'Model',
      modelTip: 'Large language chat model',
      modelMessage: 'Please select!',
      subtaskModel: 'Subtask model',
      subtaskModelTip:
        'Chat model used for subtasks such as question refinement, keyword extraction, source annotation, suggested follow-up questions and conversation titles. If not set, the main model is used. Individual models from the advanced section below take precedence.',
      subtaskModelPlaceholder: 'Default',
      agenticSubtaskModelTip:
        'Agentic routing, tool selection and the final answer use the main model. Only applicable auxiliary tasks are shown below.',
      subtaskModelsAdvanced: 'Advanced · Models per subtask',
      subtaskModelsAdvancedTip:
        'Override the model for each subtask individually. The fields show the general subtask model as default; a value is only saved once you change it. Precedence: individual model > subtask model > main model.',
      subtaskRefinement: 'Question refinement',
      subtaskRetrievalTranslation: 'Retrieval translation',
      subtaskKeywordExtraction: 'Keyword extraction',
      subtaskSourceLinking: 'Source linking',
      subtaskFollowupKeywords: 'Follow-up questions – keywords',
      subtaskFollowupGeneration: 'Follow-up questions – generation',
      subtaskConversationTitle: 'Conversation title',
      subtaskDocumentSummary: 'Document summary',
      toolsEnabled: 'Enable tool usage',
      toolsEnabledTip:
        'Enables the agentic tool loop (e.g. knowledge base search) for this chatbot. Both this and "Enable reasoning" must be on for requests to be routed through the agentic path instead of the classic answer pipeline.',
      reasoningEnabled: 'Enable reasoning',
      reasoningEnabledTip:
        'Treats the selected model as a reasoning model. Both this and "Enable tool usage" must be on for requests to be routed through the agentic path instead of the classic answer pipeline.',
      mcpTools: 'MCP tools',
      mcpToolsTip:
        'Select which MCP tools this chatbot may use. Requires "Enable tool usage" and "Enable reasoning" to be on. Configure MCP servers under Settings → MCP Tools.',
      mcpToolsPlaceholder: 'Select MCP tools…',
      consultedBuddies: 'Consulted buddies',
      consultedBuddiesTip:
        'Other chatbots this chatbot may ask for an answer. It decides itself when to ask one, hands on their sources and cites them. Offered: the chatbots of your teams, and freely available chatbots added by share link. Requires "Enable tool usage" and "Enable reasoning" to be on.',
      consultedBuddiesPlaceholder: 'Select chatbots…',
      consultedBuddyLinkPlaceholder: 'Paste a share link or chatbot id',
      consultedBuddyAdd: 'Add',
      consultedBuddyInvalidLink: 'That is not a share link or chatbot id.',
      consultedBuddyNotConsultable:
        'This chatbot cannot be consulted: it does not exist here, or it requires a login and belongs to another team.',
      consultedBuddyUnavailable: 'unavailable',
      consultedBuddyLookupFailed:
        'This chatbot could not be checked. Please try again.',
      freedom: 'Freedom',
      improvise: 'Improvise',
      precise: 'Precise',
      balance: 'Balance',
      freedomTip: `Set the freedom level to 'Precise' to strictly confine the LLM's response to your selected knowledge base(s). Choose 'Improvise' to grant the LLM greater freedom in its responses, which may lead to hallucinations. 'Balance' is an intermediate level; choose 'Balance' for more balanced responses.`,
      temperature: 'Temperature',
      temperatureMessage: 'Temperature is required',
      temperatureTip: `This parameter controls the randomness of the model's predictions. A lower temperature results in more conservative responses, while a higher temperature yields more creative and diverse responses.`,
      termsOfUseDefaultTitle: 'AI in use',
      termsOfUseDefaultText: `Buddy is an artificial intelligence you can chat with and was developed to make researching health topics easier.\n\nPlease note:\n• Your chat history is stored and may be evaluated in anonymised form.\n• Your feedback (\uD83D\uDC4D/\uD83D\uDC4E) helps us improve it.`,
      termsOfUseFooter: 'Innovative health by',
      termsOfUseBtnConfirm: 'Agree',
      topP: 'Top P',
      topPMessage: 'Top P is required',
      topPTip:
        'Also known as "nucleus sampling", this parameter sets a threshold for selecting a smaller set of the most likely words to sample from, cutting off the less probable ones.',
      presencePenalty: 'Presence penalty',
      presencePenaltyMessage: 'Presence penalty is required',
      presencePenaltyTip:
        'This discourages the model from repeating the same information by penalizing words that have already appeared in the conversation.',
      frequencyPenalty: 'Frequency penalty',
      frequencyPenaltyMessage: 'Frequency penalty is required',
      frequencyPenaltyTip:
        'Similar to the presence penalty, this reduces the model’s tendency to repeat the same words frequently.',
      maxTokens: 'Max tokens',
      maxTokensMessage: 'Max tokens is required',
      maxTokensTip: `This sets the maximum length of the model's output, measured in the number of tokens (words or pieces of words). Defaults to 512. If disabled, you lift the maximum token limit, allowing the model to determine the number of tokens in its responses.`,
      maxTokensInvalidMessage: 'Please enter a valid number for Max Tokens.',
      maxTokensMinMessage: 'Max Tokens cannot be less than 0.',
      quote: 'Show quote',
      quoteTip: 'Whether to display the original text as a reference.',
      useLLMForQuotes: 'Use LLM for quotes',
      useLLMForQuotesTip:
        'If this option is enabled, the LLM is used to identify and display the quotes. Otherwise, a statistical method is applied, which may be less accurate.',
      showFootnoteMarkers: 'Show Footnote Markers',
      showFootnoteMarkersTip:
        'Shows or hides the superscript numbers in the text that refer to footnotes.',
      showImagesTitle: 'Display images in references',
      showImagesTitleTip: 'Whether to display images in the reference overlay.',
      showReferenceDate: 'Show source date ("as of")',
      showReferenceDateTip:
        'Shows the "As of: <date>" line under each source in the reference list – the creation date of the referenced document.',
      promptIcon: 'Show prompt icon',
      promptIconTip: 'Whether to display the prompt icon in the chat messages.',
      promptViewSections: 'Sections',
      promptViewRaw: 'Raw text',
      promptSectionLines_one: '{{count}} line',
      promptSectionLines_other: '{{count}} lines',
      selfRag: 'Self-RAG',
      selfRagTip: 'Please refer to: https://huggingface.co/papers/2310.11511',
      overview: 'Chat ID',
      pv: 'Number of messages',
      uv: 'Active user number',
      speed: 'Token output speed',
      tokens: 'Consume the token number',
      round: 'Session Interaction Number',
      thumbUp: 'customer satisfaction',
      // Integrations / embed
      preview: 'Preview',
      embedded: 'Embedded',
      serviceApiEndpoint: 'Service API Endpoint',
      apiKey: 'API KEY',
      apiReference: 'API Documents',
      dateRange: 'Date Range:',
      backendServiceApi: 'API Server',
      createNewKey: 'Create new key',
      created: 'Created',
      action: 'Action',
      embedModalTitle: 'Embed into webpage',
      comingSoon: 'Coming soon',
      embedTitle: 'Full Embed',
      embedDynamicHeight: 'Dynamic height',
      embedDynamicHeightTip:
        'The chat grows with its messages instead of scrolling inside the iframe, so the website scrolls instead. Applies to the code below; other embeds of this Buddy keep the fixed height. Autoscroll has no effect in this mode.',
      embedDescription:
        'Embed the following iframe into your website at the desired location',
      embedTitleWithStartQuestion: 'Embed with initial question',
      embedTitleWithUserAuth: 'Embed with User Authentication',
      embedDescriptionWithStartQuestion:
        'Iframe and script for your website.\nProvide an initial question that should automatically start the chat.',
      embedDescriptionWithUserAuth:
        'Iframe and script for your website with user authentication.',
      embedStartQuestionInput: 'Your initial question',
      embedUserAuthNote:
        'User authentication allows embedding the Buddy into your application while making it available only to specific users or user groups (e.g., premium users).\n\nIf this feature is enabled, your application must authorize access to the Buddy. Only authorized users with a valid token can then access the embedded Buddy.\n\nAuthentication is performed using JWT tokens issued by your application.\n\nThis feature must be enabled in the Buddy settings and a key pair (public/private) must be generated. You can do this conveniently in the Buddy settings under `Assistant > Miscellaneous > Restrict access > User authentication`.\n\nUse the private key to sign the tokens in your application, while the public key is stored in the Buddy to verify the tokens.\n\n**How to pass the token:** The iframe URL must include `auth_strategy=user_token`. This tells the Buddy to wait for the token via postMessage before initializing — without it, the Buddy might start using a cached session token before your token arrives. Once the chat is ready, it emits a `chat_loaded` message. Your page listens for this event and responds by sending the token via `postMessage` with `type: "set_user_token"`.\n\nIf you have any questions about implementing user authentication, feel free to contact our support team.',
      embedDescriptionWithUserAuthRenewal: 'Script for token renewal',
      embedUserAuthRenewalNote:
        'For security reasons, JWT tokens often have a limited validity period (e.g., 15 minutes). After this period, a new token must be obtained to continue accessing the embedded Buddy.\n\nTo facilitate this process, you can implement a token renewal mechanism in your application. This mechanism should periodically request a new JWT token from your backend and update the embedded Buddy with the new token via `postMessage` (`type: "set_user_token"`).\n\nThe following example script demonstrates how to send the initial token on `chat_loaded` and renew it periodically. Adjust the renewal interval as needed based on your security requirements.',
      partialTitle: 'Partial Embed',
      extensionTitle: 'Chrome Extension',
      tokenError: 'Please create API key first.',
      searching: 'Searching...',
      parsing: 'Parsing',
      uploading: 'Uploading',
      uploadFailed: 'Upload failed',
      regenerate: 'Regenerate',
      read: 'Read content',
      tts: 'Text to speech',
      ttsTip:
        'Ensure you select a TTS model on the Settings page before enabling this toggle to play text as audio.',
      ttsVoice: 'Voice',
      ttsVoiceTip: 'Select the voice for text-to-speech conversion.',
      stt: 'Speech to text',
      sttTip:
        'Ensure you select a "Speech to text model" on the Settings page before enabling this toggle to convert microphone audio to text',
      diarization: 'Speaker Diarization',
      diarizationTip:
        'Enables the diarization API endpoint for this chatbot. Requires a Diarization model to be configured in System Model Settings.',
      diarizationCorrection: 'Diarization LLM Correction',
      diarizationCorrectionTip:
        "After diarization, pass the result through the dialog's LLM to correct speaker attribution and transcription errors.",
      diarizationCorrectionPrompt: 'Correction Prompt',
      diarizationCorrectionPromptTip:
        'Prompt sent to the LLM together with the diarization JSON. The LLM must return valid JSON in the same format.',
      callMode: 'Call Mode',
      callModeTip:
        "In Call Mode you can speak with the Chatbot like you're having a phone-call. Needs a STT and TTS model to be set in System Settings.",
      callModeBackgroundColor: 'Call mode background color',
      callModeBackgroundColorTip:
        'Set the background color that will be displayed in call mode.',
      callModeTextColor: 'Call mode text color',
      callModeTextColorTip:
        'Specify the color of the text displayed in call mode.',
      callModeTextBlurColor: 'Text blur color in call mode',
      callModeTextBlurColorTip:
        'Specify the color of the text blur effect in call mode.',
      callModeButtonsColor: 'Call mode button color',
      callModeButtonsColorTip: 'Specify the color of the buttons in call mode',
      recording: 'Recording…',
      startRecording: 'Start Recording',
      cancelRecording: 'Cancel Recording',
      submitRecording: 'Convert Recording to Text',
      startCallMode: 'Start Call Mode',
      stopCallMode: 'Stop Call Mode',
      listen: 'Listen',
      stop: 'Stop',
      relatedQuestion: 'Related question',
      answerTitle: 'Buddy',
      multiTurn: 'Multi-turn optimization',
      multiTurnTip:
        'This optimizes user queries using context in a multi-round conversation. When enabled, it will consume additional LLM tokens.',
      howUseId: 'How to use chat ID?',
      description: 'Description of assistant',
      messageReferencesLabel: 'References',
      urlDateLabel: 'As of',
    },
    setting: {
      profile: 'Profile',
      profileDescription: 'Update your photo and personal details here.',
      maxTokens: 'Max Tokens',
      maxTokensMessage: 'Max Tokens is required',
      maxTokensTip: `This sets the maximum length of the model's output, measured in the number of tokens (words or pieces of words). Defaults to 512. If disabled, you lift the maximum token limit, allowing the model to determine the number of tokens in its responses.`,
      maxTokensInvalidMessage: 'Please enter a valid number for Max Tokens.',
      maxTokensMinMessage: 'Max Tokens cannot be less than 0.',
      password: 'Password',
      passwordDescription:
        'Please enter your current password to change your password.',
      model: 'Model Providers',
      modelDescription: 'Set the model parameter and API KEY here.',
      team: 'Team',
      system: 'System',
      logout: 'Log out',
      api: 'API',
      username: 'Username',
      usernameMessage: 'Please input your username!',
      photo: 'Your photo',
      photoDescription: 'This will be displayed on your profile.',
      colorSchema: 'Color schema',
      colorSchemaMessage: 'Please select your color schema!',
      colorSchemaPlaceholder: 'select your color schema',
      bright: 'Bright',
      dark: 'Dark',
      timezone: 'Time zone',
      timezoneMessage: 'Please input your timezone!',
      timezonePlaceholder: 'select your timezone',
      email: 'Email address',
      emailDescription: 'Once registered, E-mail cannot be changed.',
      currentPassword: 'Current password',
      currentPasswordMessage: 'Please input your password!',
      newPassword: 'New password',
      newPasswordMessage: 'Please input your password!',
      newPasswordDescription:
        'Your new password must be more than 12 characters.',
      passwordTooWeak:
        'Password is too weak. Please choose a stronger password.',
      confirmPassword: 'Confirm new password',
      confirmPasswordMessage: 'Please confirm your password!',
      confirmPasswordNonMatchMessage:
        'The new password that you entered do not match!',
      cancel: 'Cancel',
      addedModels: 'Added models',
      modelsToBeAdded: 'Models to be added',
      addTheModel: 'Add the model',
      apiKey: 'API-Key',
      apiKeyMessage:
        'Please enter the API key (for locally deployed model,ignore this).',
      apiKeyTip:
        'The API key can be obtained by registering the corresponding LLM supplier.',
      showMoreModels: 'Show more models',
      baseUrl: 'Base-Url',
      baseUrlTip:
        'If your API key is from OpenAI, just ignore it. Any other intermediate providers will give this base url with the API key.',
      modify: 'Modify',
      systemModelSettings: 'System Model Settings',
      chatModel: 'Chat model',
      chatModelTip:
        'The default chat LLM all the newly created knowledgebase will use.',
      embeddingModel: 'Embedding model',
      embeddingModelTip:
        'The default embedding model all the newly created knowledgebase will use.',
      img2txtModel: 'Img2txt model',
      img2txtModelTip:
        'The default multi-module model all the newly created knowledgebase will use. It can describe a picture or video.',
      sequence2txtModel: 'Sequence2txt model',
      sequence2txtModelTip:
        'The default ASR model all the newly created knowledgebase will use. Use this model to translate voices to corresponding text.',
      rerankModel: 'Rerank model',
      rerankModelTip: `The default rerank model is used to rerank chunks retrieved by users' questions.`,
      speech2txtModel: 'Speech2txt model',
      speech2txtModelTip:
        'The default speech2txt/ASR model, which processes voice requests in chats.',
      diarizationModel: 'Diarization model',
      diarizationModelTip:
        'The default diarization model used for speaker-attributed transcription via the API.',
      ttsModel: 'TTS Model',
      ttsModelTip:
        'The default TTS model will be used to generate speech during conversations upon request.',
      evalModel: 'Evaluation Model',
      evalModelTip:
        'The Model which should be used to judge testcases (Judge-Model).',
      workspace: 'Workspace',
      upgrade: 'Upgrade',
      addLlmTitle: 'Add LLM',
      modelName: 'Model name',
      modelID: 'Model ID',
      modelUid: 'Model UID',
      modelNameMessage: 'Please input your model name!',
      modelType: 'Model type',
      modelTypeMessage: 'Please input your model type!',
      addLlmBaseUrl: 'Base url',
      baseUrlNameMessage: 'Please input your base url!',
      vision: 'Does it support Vision?',
      ollamaLink: 'How to integrate {{name}}',
      FishAudioLink: 'How to use FishAudio',
      TencentCloudLink: 'How to use TencentCloud ASR',
      volcModelNameMessage: 'Please input your model name!',
      addEndpointID: 'EndpointID of the model',
      endpointIDMessage: 'Please input your EndpointID of the model',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Please input your ARK_API_KEY',
      bedrockModelNameMessage: 'Please input your model name!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Please input your ACCESS KEY',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Please input your SECRET KEY',
      bedrockRegion: 'AWS Region',
      bedrockRegionMessage: 'Please select!',
      'us-east-1': 'US East (N. Virginia)',
      'us-west-2': 'US West (Oregon)',
      'ap-southeast-1': 'Asia Pacific (Singapore)',
      'ap-northeast-1': 'Asia Pacific (Tokyo)',
      'eu-central-1': 'Europe (Frankfurt)',
      'us-gov-west-1': 'AWS GovCloud (US-West)',
      'ap-southeast-2': 'Asia Pacific (Sydney)',
      addHunyuanSID: 'Hunyuan Secret ID',
      HunyuanSIDMessage: 'Please input your Secret ID',
      addHunyuanSK: 'Hunyuan Secret Key',
      HunyuanSKMessage: 'Please input your Secret Key',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Please input your Secret ID',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Please input your Secret Key',
      SparkModelNameMessage: 'Please select Spark model',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'please input your APIPassword',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'please input your APP ID',
      addSparkAPISecret: 'Spark APISecret',
      SparkAPISecretMessage: 'please input your APISecret',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'please input your APIKey',
      yiyanModelNameMessage: 'Please input model name',
      addyiyanAK: 'yiyan API KEY',
      yiyanAKMessage: 'Please input your API KEY',
      addyiyanSK: 'yiyan Secret KEY',
      yiyanSKMessage: 'Please input your Secret KEY',
      FishAudioModelNameMessage:
        'Please give your speech synthesis model a name',
      addFishAudioAK: 'Fish Audio API KEY',
      addFishAudioAKMessage: 'Please input your API KEY',
      addFishAudioRefID: 'FishAudio Reference ID',
      addFishAudioRefIDMessage:
        'Please input the Reference ID (leave blank to use the default model).',
      GoogleModelIDMessage: 'Please input your model ID!',
      addGoogleProjectID: 'Project ID',
      GoogleProjectIDMessage: 'Please input your Project ID',
      addGoogleServiceAccountKey:
        'Service Account Key(Leave blank if you use Application Default Credentials)',
      GoogleServiceAccountKeyMessage:
        'Please input Google Cloud Service Account Key in base64 format',
      addGoogleRegion: 'Google Cloud Region',
      GoogleRegionMessage: 'Please input Google Cloud Region',
      modelProvidersWarn: `Please add both embedding model and LLM in <b>Settings > Model Providers</b>  firstly. Then, set them in 'System model settings'.`,
      evalModelWarn: `Please select Evaluationmodel under <b>Settings > Model Providers > System Model Settings</b>.`,
      apiVersion: 'API-Version',
      apiVersionMessage: 'Please input API version',
      add: 'Add',
      updateDate: 'Update Date',
      role: 'Role',
      invite: 'Invite',
      agree: 'Accept',
      refuse: 'Decline',
      teamMembers: 'Team Members',
      joinedTeams: 'Joined Teams',
      sureDelete: 'Are you sure to remove this member?',
      quit: 'Quit',
      sureQuit: 'Are you sure you want to quit the team you joined?',
      users: 'Users',
      // Task queues (superuser)
      queues: 'Task Queues',
      poolChat: 'Chat uploads',
      poolAnalyze: 'Document analysis',
      poolCrawl: 'Crawls',
      queueSlots: '{{count}} worker(s)',
      queuePoolUnserved: 'no worker — this work cannot run',
      queuePoolSlotsHint:
        'Workers dedicated to this kind of work, each running one task at a time. Every worker is assigned its pool when it starts, so a crawl can never occupy a worker document analysis needs, and vice versa. Zero workers means this kind of work will not run at all — it queues up silently — and changing the split means restarting the task executors.',
      queueRunning: 'Running',
      queueWaiting: 'Waiting',
      queueTenantsWaiting: 'Tenants waiting',
      queueTenants: 'Per tenant',
      queueTenant: 'Tenant',
      queueActions: 'Actions',
      queueLaneCellHint:
        'running / waiting, then how long the oldest waiting task has been queued and the 95th percentile time-to-start. A percentile marked “?” rests on fewer than {{count}} samples and is noise.',
      queuePaused: 'Paused',
      queuePausedSince: 'Paused since {{since}} by {{by}}',
      queuePause: 'Pause',
      queueResume: 'Resume',
      queuePauseNew: 'Pause new work',
      queuePauseAll: 'Pause everything',
      queuePauseAllConfirm:
        'Block new work and hold this tenant’s running crawls? A crawl stops at its next batch boundary and keeps its place, so nothing is lost. The holds stay in force after you resume the tenant — lift them in the crawls list.',
      queueCancelQueued: 'Cancel queued',
      queueCancelQueuedConfirm:
        'Cancel this tenant’s queued tasks? Work already running is left to finish.',
      queueCancelAll: 'Cancel all',
      queueCancelAllConfirm:
        'Cancel everything for this tenant, including work already running? A running task cannot be stopped instantly — it stops at its next checkpoint, which can take up to 45 minutes for a large PDF.',
      queueCrawls: 'Crawls',
      queueCrawlName: 'Crawl',
      queueSegments: 'Segments',
      queuePagesCrawled: 'Pages crawled',
      queueCrawlUpdatedAt: 'Last activity',
      queueSuspended: 'Waiting for a turn',
      queueStopping: 'Stopping',
      queueNoActiveCrawls: 'No crawl is running or waiting for a turn.',
      queueCrawlRunning: 'Crawling',
      queueCrawlOrphaned: 'Orphaned',
      queueCrawlOrphanedHint:
        'Nothing is crawling. No task exists that could carry this run on — usually a worker stopped mid-crawl — so the status it still reports is stale. It is cleared automatically within a few minutes, or at once by Cancel.',
      queueCrawlHeld: 'Held by an administrator',
      queueCrawlHeldSince: ' since {{since}} by {{by}}',
      queueCrawlHoldConfirm:
        'Hold this crawl? It stops at its next batch boundary and keeps its place, so nothing is lost and it carries on from there when you resume it.',
      queueWorkers: 'Workers',
      queueWorker: 'Worker',
      queuePool: 'Pool',
      queueServers: 'Serving',
      queueHeartbeat: 'Last heartbeat',
      queueDone: 'Done',
      queueFailed: 'Failed',
      queueNoWorkers: 'No task executor is reporting in.',
      queueConfig: 'Scheduler settings',
      queueConfigSaved: 'Saved. In effect everywhere within a few seconds.',
      queueConfig_queue_per_tenant: 'Tasks per tenant',
      queueConfigHint_queue_per_tenant:
        'How many slots one tenant may hold at once in a queue pool. Soft: a slot is never left idle while work exists.',
      queueConfig_chat_capacity: 'Chat upload slots',
      queueConfigHint_chat_capacity:
        'Concurrent inline chat parses. Takes effect within seconds in both directions, with no restart. Do not set it far above the number of parse slots the MinerU service has — the extra uploads then queue there instead, reporting “analysing” while they wait.',
      queueConfig_chat_per_tenant: 'Chat uploads per tenant',
      queueConfigHint_chat_per_tenant:
        'Leave empty to divide the pool evenly between whoever is uploading, which also means a single tenant gets all of it.',
      queueConfig_chat_pause_wait_seconds: 'Paused upload wait (s)',
      queueConfigHint_chat_pause_wait_seconds:
        'How long a paused tenant’s chat upload waits before failing with a message. Queued document analysis waits indefinitely instead — a chat window cannot.',
      queueConfig_crawl_slice_pages: 'Crawl slice (pages)',
      queueConfigHint_crawl_slice_pages:
        'Pages a crawl may fetch before it offers its slot to another tenant’s crawl. Honoured to the nearest batch, so a few pages over is expected.',
      queueConfig_crawl_slice_seconds: 'Crawl slice (seconds)',
      queueConfigHint_crawl_slice_seconds:
        'The same limit in time, whichever is reached first. This is what covers a slow or rate-limited site.',
      queueConfig_crawl_frontier_batch_size: 'Crawl batch size',
      queueConfigHint_crawl_frontier_batch_size:
        'How many URLs a crawl fetches at once. Also how quickly a Stop takes effect, and the granularity the slice limits are honoured to.',
      createUser: 'Create User',
      superuser: 'Superuser',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      lastLogin: 'Last Login',
      searchUsers: 'Search by nickname or email',
      resetPassword: 'Reset Password',
      sureResetPassword:
        'Are you sure you want to reset this user’s password? A new password will be generated.',
      userCreated: 'User created',
      passwordReset: 'Password reset',
      oneTimePasswordWarning:
        'Copy this password now — it will not be shown again.',
      mcp: 'MCP Tools',
      'mcp-servers': 'MCP Server Catalog',
      // What each MCP page is for, shown under its title (McpPageIntro).
      mcpServersIntro:
        'The central catalogue of MCP servers. Every server registered here can be enabled by all tenants under “MCP Tools”.',
      mcpServersIntroItem1:
        'Register a server with its URL, transport and — if it needs credentials — its configuration properties.',
      mcpServersIntroItem2:
        'Decide per property who supplies the value: you, the tenant, or the calling application with each request.',
      mcpServersIntroItem3:
        'Saving checks that the server is reachable and reads its tools; disabling a server withdraws it from all tenants.',
      // Allowed domains section on the catalogue page.
      mcpAllowedDomains: 'Allowed domains for tenants’ own servers',
      mcpAllowedDomainsIntro:
        'Under “MCP Tools”, tenants can add their own MCP servers, but only for publicly reachable addresses.',
      mcpAllowedDomainsIntroItem1:
        'A domain listed here is allowed as well: tenants can add servers for it even though this would otherwise be refused.',
      mcpAllowedDomainsIntroItem2:
        'Always state the port. Only that port is opened — everything else on the same server stays closed.',
      mcpAllowedDomainsIntroItem3:
        'Only add domains you trust — every tenant may then use them. If you remove one, the servers tenants have added for it stop working.',
      mcpAllowedDomainAdd: 'Add domain',
      mcpAllowedDomainPlaceholder: 'mcp.example.com:8000',
      mcpNoAllowedDomains:
        'No domains yet — tenants can only add publicly reachable servers.',
      mcpAllowedDomainRemove: 'Remove',
      mcpAllowedDomainRemoveConfirm: 'Remove this domain?',
      mcpAllowedDomainSaved: 'Domain added',
      mcpAllowedDomainRemoved: 'Domain removed',
      mcpToolsIntro:
        'Here you decide which MCP servers your chatbots may use — a server from the catalogue or one of your own.',
      mcpToolsIntroItem1:
        'Enable a server from the catalogue and fill in the values it asks for, or add your own server with its URL.',
      mcpToolsIntroItem2:
        'Choose which of its tools your chatbots may call; leave the selection empty to allow all of them.',
      mcpToolsIntroItem3:
        'Enabled configurations can then be selected per chatbot in the chatbot settings under “MCP tools”.',
      mcpAddServer: 'Add server',
      mcpEditServer: 'Edit server',
      mcpServerName: 'Name',
      mcpServerNameTip:
        'Shown to users when they pick this server from the catalog.',
      mcpServerDescription: 'Description',
      mcpServerDescriptionTip:
        'Shown to users as a hint after they select this server. Explain what the server does and which values they have to supply.',
      mcpServerUrl: 'URL',
      mcpServerUrlTip:
        'Endpoint of the MCP server including its path, usually ending in /mcp. It is called by the backend, so an internal address or Docker service name works here.',
      mcpServerUrlRule: 'The URL has to start with http:// or https://',
      mcpTransport: 'Transport',
      mcpTransportTip:
        'How the backend talks to the server: “streamable-http” for current MCP servers, “sse” only for older ones that expose a server-sent-events endpoint.',
      mcpEnabled: 'Enabled',
      mcpServerEnabledTip:
        'Only enabled servers appear in the catalog for users. Disabling one hides it and stops all tool calls to it.',
      mcpTools: 'Tools',
      mcpConfigProperties: 'Configuration properties',
      mcpNoConfigProperties:
        'No configuration properties yet. Add one for every HTTP header the server expects, e.g. an API key.',
      mcpNewProperty: 'New property',
      mcpAddProperty: 'Add property',
      mcpRemoveProperty: 'Remove property',
      mcpPropKey: 'Key',
      mcpPropKeyTip:
        'Name of the HTTP header the value is sent as, e.g. “Authorization” or “X-Api-Key”. It has to match what the MCP server expects.',
      mcpPropLabel: 'Label',
      mcpPropLabelTip:
        'Field name shown to the user instead of the key. Leave empty to show the key itself.',
      mcpPropDescription: 'Description',
      mcpPropDescriptionTip:
        'Help text shown to the user next to the input field — where to get the value, which format it needs.',
      mcpPropSourceTip:
        'Who supplies the value: fixed by you, a default the user may override, filled in by the user, or sent by the calling application with every request (never stored).',
      mcpPropValue: 'Value',
      mcpPropValueTip:
        'The value stored in the catalog. Used as the value for “Admin fixed” and as the default for “Admin default”; leave empty for the other types.',
      mcpPropPrefix: 'Prefix',
      mcpPropPrefixTip:
        'Prepended to the value when the header is sent. Use “Bearer ” (with the trailing space) for a bearer token, so the stored secret stays just the token.',
      mcpPropSecret: 'Secret',
      mcpPropSecretTip:
        'Treat the value as a credential: it is entered masked and never sent back to the browser.',
      mcpPropRequired: 'Required',
      mcpPropRequiredTip:
        'The configuration cannot be saved without a value for this property.',
      mcpSourceAdminFixed: 'Admin fixed',
      mcpSourceAdminDefault: 'Admin default',
      mcpSourceTenantInput: 'Filled by user',
      mcpSourceRequestInput: 'Supplied per request',
      mcpPropKeyHeaderRule:
        'Use letters, digits and hyphens only — a key with underscores is dropped by the reverse proxy.',
      mcpRequestHeaders: 'Request header',
      mcpRequestInputTenantHint:
        'This server expects a value from the calling application on every request. Configure the app with the header name shown here — the value is never stored.',
      mcpRequestInputAdminHint:
        'Template of the header the calling application has to send. The final name contains the ID of the user’s MCP configuration and is shown to them on the MCP tools page.',
      mcpRequestInputPendingId:
        'The header name contains this entry’s ID, so it is shown once you have saved.',
      mcpRequestInputNoToolsHint:
        'This server’s tools can only be listed during a request. Leave the selection empty to allow all of them.',
      mcpEdit: 'Edit',
      mcpDelete: 'Delete',
      mcpDeleteConfirm: 'Delete this entry?',
      mcpSaved: 'Saved',
      mcpConnectFailed: 'Failed to connect to the MCP server',
      // The keys below are returned as `message` by the backend — see the
      // message-key constants in api/services/mcp_service.py. `{{detail}}` is
      // the data the service sends after the `::` separator.
      mcpUnreachable:
        'The MCP server could not be reached. Please check the URL and try again.',
      mcpServerNotFound: 'This MCP server no longer exists.',
      mcpServerNotFoundOrDisabled:
        'This MCP server is not available. Please contact your administrator.',
      mcpConfigNotFound: 'This MCP configuration no longer exists.',
      mcpCustomRequiresUrl: 'Please enter the URL of the MCP server.',
      mcpInvalidUrl: 'Please enter a valid http:// or https:// URL.',
      mcpDomainInvalid:
        'Please enter a valid domain with a port, for example mcp.example.com:8000.',
      mcpDomainRequiresPort:
        'Please add the port, for example mcp.example.com:8000. Only that port is opened.',
      mcpDomainExists: '“{{detail}}” is already in the list.',
      mcpPrivateUrl:
        'This address is not permitted. Please use a publicly reachable URL, or ask your administrator to add the server to the catalog.',
      mcpMissingConfig: 'Please fill in the required configuration: {{detail}}',
      mcpServerImmutable:
        'The server of an existing MCP configuration cannot be changed. Please create a new entry instead.',
      mcpPropKeyInvalid:
        'The configuration key “{{detail}}” is not a valid header name. Please use letters, digits and hyphens only.',
      mcpPropKeyReserved:
        '“{{detail}}” is reserved for Buddy’s own request headers. Please choose a different key.',
      mcpPropKeyDuplicate:
        'The configuration key “{{detail}}” is used twice. Please use each key only once.',
      mcpPropKeyCatalogOwned:
        'The server already defines “{{detail}}” itself. Please choose a different key.',
      mcpTenantSourceNotAllowed:
        'The property type “{{detail}}” can only be set by an administrator.',
      mcpAddConfig: 'Add MCP server',
      mcpEditConfig: 'Edit MCP server',
      mcpMode: 'Type',
      mcpModeCatalog: 'From catalog',
      mcpModeCustom: 'Custom',
      mcpServer: 'Server',
      mcpSelectedTools: 'Enabled tools',
      mcpSelectedToolsTip:
        'Leave empty to expose all of the server’s tools to your chatbots.',
      mcpAllTools: 'All tools',
      mcpAllowedTools: 'Allowed tools',
      mcpAllowedToolsTip:
        'Which of this server’s tools users may enable. Leave empty to allow all of them.',
      mcpSourceType: 'Type',
      mcpSecretSet: '•••••• (set — leave blank to keep)',
      mcpCustomToolsHint:
        'Tools are discovered automatically when you save and connect to the server.',
      mcpExtraProperties: 'Additional headers',
      mcpExtraPropertiesHint:
        'Headers to send to this server on top of what it already defines above. Keys the server defines itself cannot be redefined here.',
      mcpOwnPropertiesHint:
        'Headers to send to your server, for example an API key or an authorization token. The key is the header name.',
      mcpTenantPropValueTip:
        'The value sent as this header. A secret value is stored masked and never shown again — leave the field empty to keep it.',
      mcpTenantSourceTip:
        '“Filled by user” takes the value you enter here. “Supplied per request” expects it from the calling application on every request and stores nothing.',
      mcpPropKeyReservedRule:
        'This key is reserved for Buddy’s own request headers.',
      mcpPropKeyDuplicateRule: 'This key is already used by another property.',
      mcpPropKeyCatalogOwnedRule: 'The server already defines this key itself.',
      mcpCacheTools: 'Cache tools',
      mcpCacheToolsTip:
        'Store the tool schemas in the database instead of listing them from the server on every use. Faster, but schema changes on the server only show up after a refresh. Saving refreshes the cache.',
      mcpRefreshTools: 'Refresh tools',
      mcpClearCache: 'Clear cache',
      mcpToolsRefreshed: '{{num}} tools found',
      mcpToolsCached: '{{num}} cached',
      mcpToolsLive: 'live',
      mcpActions: 'Actions',
    },
    message: {
      logout: 'logout',
      logged: 'logged!',
      pleaseSelectChunk: 'Please select chunk!',
      modified: 'Modified',
      created: 'Created',
      deleted: 'Deleted',
      downloadFailed: 'Download failed.',
      renamed: 'Renamed',
      operated: 'Operated',
      updated: 'Updated',
      uploaded: 'Uploaded',
      200: 'The server successfully returns the requested data.',
      201: 'Create or modify data successfully.',
      202: 'A request has been queued in the background (asynchronous task).',
      204: 'Data deleted successfully.',
      400: 'There was an error in the request issued, and the server did not create or modify data.',
      401: 'The user does not have permissions (wrong token, username, password).',
      403: 'The user is authorized, but access is prohibited.',
      404: 'The request was made for a record that does not exist, and the server did not perform the operation.',
      406: 'The requested format is not available.',
      410: 'The requested resource has been permanently deleted and will not be available again.',
      413: 'The total size of the files uploaded at once is too large.',
      422: 'When creating an object, a validation error occurred.',
      429: 'Too many requests. Please slow down and try again after one minute.',
      500: 'A server error occurred, please check the server.',
      502: 'Gateway error.',
      503: 'The service is unavailable and the server is temporarily overloaded or undergoing maintenance.',
      504: 'Gateway timeout.',
      requestError: 'Request error',
      networkAnomalyDescription:
        'There is an abnormality in your network and you cannot connect to the server.',
      networkAnomaly: 'network anomaly',
      hint: 'hint',
    },
    fileManager: {
      name: 'Name',
      uploadDate: 'Upload Date',
      knowledgeBase: 'Knowledge Base',
      size: 'Size',
      action: 'Action',
      addToKnowledge: 'Link to Knowledge Base',
      pleaseSelect: 'Please select',
      newFolder: 'New Folder',
      file: 'File',
      uploadFile: 'Upload File',
      directory: 'Directory',
      uploadTitle: 'Click or drag file to this area to upload',
      uploadDescription:
        'Support for a single or bulk upload. Strictly prohibited from uploading company data or other banned files.',
      local: 'Local uploads',
      website: 'Website',
      s3: 'S3 uploads',
      preview: 'Preview',
      fileError: 'File error',
      uploadLimit:
        'The file size cannot exceed 10M, and the total number of files cannot exceed 128',
      destinationFolder: 'Destination folder',
      replacingExistingFilesWarning:
        'The following files will be overwritten with this upload:',
    },
    feedback: {
      reportProblem: 'Report a problem',
      sendFeedback: 'Send feedback',
      report: 'Report',
      send: 'Send',
      reportProblemDescription:
        'The answer is not correct? Please specify the type of problem. We will then review this chat session anonymously.',
      sendFeedbackDescription:
        'Thank you for your feedback! You are welcome to leave an optional comment.',
      freetextCommentPlaceholder: 'Comment (optional)',
      editHint: 'Please select an answer option',
      answer: {
        wrong: 'Wrong',
        harmful: 'Harmful/Illegal',
        offensive: 'Offensive/Discriminatory/Unfair',
        repetition: 'Repetition',
        unclear: 'Unclear',
        insufficient: 'Insufficient',
        other: 'Other',
      },
    },
    flow: {
      cite: 'Cite',
      citeTip: 'citeTip',
      name: 'Name',
      nameMessage: 'Please input name',
      description: 'Description',
      examples: 'Examples',
      to: 'To',
      msg: 'Messages',
      messagePlaceholder: 'message',
      messageMsg: 'Please input message or delete this field.',
      addField: 'Add option',
      addMessage: 'Add message',
      loop: 'Loop',
      loopTip:
        'Loop is the upper limit of the number of loops of the current component, when the number of loops exceeds the value of loop, it means that the component can not complete the current task, please re-optimize agent',
      yes: 'Yes',
      no: 'No',
      key: 'Key',
      componentId: 'Component ID',
      add: 'Add',
      operation: 'operation',
      run: 'Run',
      save: 'Save',
      title: 'ID:',
      beginDescription: 'This is where the flow begins.',
      answerDescription: `A component that serves as the interface between human and bot, receiving user inputs and displaying the agent's responses.`,
      retrievalDescription: `A component that retrieves information from a specified knowledge base and returns 'Empty response' if no information is found. Ensure the correct knowledge base is selected.`,
      generateDescription: `A component that prompts the LLM to generate responses. Ensure the prompt is set correctly.`,
      categorizeDescription: `A component that uses the LLM to classify user inputs into predefined categories. Ensure you specify the name, description, and examples for each category, along with the corresponding next component.`,
      relevantDescription: `A component that uses the LLM to assess whether the upstream output is relevant to the user's latest query. Ensure you specify the next component for each judge result.`,
      rewriteQuestionDescription: `A component that refines a user query if it fails to retrieve relevant information from the knowledge base. It repeats this process until the predefined looping upper limit is reached. Ensure its upstream is 'Relevant' and downstream is 'Retrieval'. `,
      messageDescription:
        "A component that sends out a static message. If multiple messages are supplied, it randomly selects one to send. Ensure its downstream is 'Answer', the interface component.",
      keywordDescription: `A component that retrieves top N search results from user's input. Ensure the TopN value is set properly before use.`,
      switchDescription: `A component that evaluates conditions based on the output of previous components and directs the flow of execution accordingly. It allows for complex branching logic by defining cases and specifying actions for each case or default action if no conditions are met.`,
      wikipediaDescription: `A component that searches from wikipedia.org, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
        {input}
  The above is the content you need to summarize.`,
      createGraph: 'Create agent',
      createFromTemplates: 'Create from templates',
      retrieval: 'Knowledge Retrieval',
      generate: 'Generate',
      answer: 'Interact',
      categorize: 'Categorize',
      relevant: 'Relevant',
      rewriteQuestion: 'Rewrite',
      rewrite: 'Rewrite',
      begin: 'Begin',
      message: 'Message',
      blank: 'Blank',
      createFromNothing: 'Create your agent from scratch',
      addItem: 'Add Item',
      addSubItem: 'Add Sub Item',
      nameRequiredMsg: 'Name is required',
      nameRepeatedMsg: 'The name cannot be repeated',
      keywordExtract: 'Keyword',
      keywordExtractDescription: `A component that extracts keywords from a user query, with Top N specifying the number of keywords to extract.`,
      baidu: 'Baidu',
      baiduDescription: `A component that searches from baidu.com, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'A component that searches from duckduckgo.com, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      channel: 'Channel',
      channelTip: `Perform text search or news search on the component's input`,
      text: 'Text',
      news: 'News',
      messageHistoryWindowSize: 'Message window size',
      messageHistoryWindowSizeTip:
        'The  window size of conversation history that needed to be seen by LLM. The larger the better. But be careful with the maximum content length of LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'A component that searches from https://pubmed.ncbi.nlm.nih.gov/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      email: 'Email',
      emailTip:
        'E-mail is a required field. You must input an E-mail address here.',
      arXiv: 'ArXiv',
      arXivDescription:
        'A component that searches from https://arxiv.org/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      sortBy: 'Sort by',
      submittedDate: 'Submitted date',
      lastUpdatedDate: 'Last updated date',
      relevance: 'Relevance',
      google: 'Google',
      googleDescription:
        'A component that searches from https://www.google.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'A component that searches from https://www.bing.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from microsoft.com.',
      apiKey: 'API KEY',
      country: 'Country&Region',
      language: 'Language',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'A component that searches https://scholar.google.com/. You can use Top N to specify the number of search results.',
      yearLow: 'Year low',
      yearHigh: 'Year high',
      patents: 'Patents',
      data: 'Data',
      deepL: 'DeepL',
      deepLDescription:
        'A component that gets more specialized translations from https://www.deepl.com/.',
      authKey: 'Auth key',
      sourceLang: 'Source language',
      targetLang: 'Target language',
      gitHub: 'GitHub',
      gitHubDescription:
        'A component that searches for repositories from https://github.com/. You can use Top N to specify the number of search results.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'A component that gets specialized translations from https://fanyi.baidu.com/.',
      appid: 'App ID',
      secretKey: 'Secret key',
      domain: 'Domain',
      transType: 'Translation type',
      baiduSecretKeyOptions: {
        translate: 'General translation',
        fieldtranslate: 'Field translation',
      },
      baiduDomainOptions: {
        it: 'Information technology',
        finance: 'Financial and economics',
        machinery: 'Machinery manufacturing',
        senimed: 'Biomedicine',
        novel: 'Online literature',
        academic: 'Academic paper',
        aerospace: 'Aerospace',
        wiki: 'Humanities and social sciences',
        news: 'News and information',
        law: 'Laws and regulations',
        contract: 'Contract',
      },
      baiduSourceLangOptions: {
        auto: 'Auto detect',
        zh: 'Chinese',
        en: 'English',
        yue: 'Cantonese',
        wyw: 'Classical Chinese',
        jp: 'Japanese',
        kor: 'Korean',
        fra: 'French',
        spa: 'Spanish',
        th: 'Thai',
        ara: 'Arabic',
        ru: 'Russian',
        pt: 'Portuguese',
        de: 'German',
        it: 'Italian',
        el: 'Greek',
        nl: 'Dutch',
        pl: 'Polish',
        bul: 'Bulgarian',
        est: 'Estonian',
        dan: 'Danish',
        fin: 'Finnish',
        cs: 'Czech',
        rom: 'Romanian',
        slo: 'Slovenian',
        swe: 'Swedish',
        hu: 'Hungarian',
        cht: 'Traditional Chinese',
        vie: 'Vietnamese',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'A component that retrieves weather information, such as temperature and air quality, from https://www.qweather.com/.',
      lang: 'Language',
      type: 'Type',
      webApiKey: 'Web API key',
      userType: 'User type',
      timePeriod: 'Time period',
      qWeatherLangOptions: {
        zh: 'Simplified Chinese',
        'zh-hant': 'Traditional Chinese',
        en: 'English',
        de: 'German',
        es: 'Spanish',
        fr: 'French',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        ru: 'Russian',
        hi: 'Hindi',
        th: 'Thai',
        ar: 'Arabic',
        pt: 'Portuguese',
        bn: 'Bengali',
        ms: 'Malay',
        nl: 'Dutch',
        el: 'Greek',
        la: 'Latin',
        sv: 'Swedish',
        id: 'Indonesian',
        pl: 'Polish',
        tr: 'Turkish',
        cs: 'Czech',
        et: 'Estonian',
        vi: 'Vietnamese',
        fil: 'Filipino',
        fi: 'Finnish',
        he: 'Hebrew',
        is: 'Icelandic',
        nb: 'Norwegian',
      },
      qWeatherTypeOptions: {
        weather: 'Weather forecast',
        indices: 'Weather life index',
        airquality: 'Air quality',
      },
      qWeatherUserTypeOptions: {
        free: 'Free subscriber',
        paid: 'Paid subscriber',
      },
      qWeatherTimePeriodOptions: {
        now: 'Now',
        '3d': '3 days',
        '7d': '7 days',
        '10d': '10 days',
        '15d': '12 days',
        '30d': '30 days',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'A component that performs SQL queries on a relational database, supporting querying from MySQL, PostgreSQL, or MariaDB.',
      dbType: 'Database Type',
      database: 'Database',
      username: 'Username',
      host: 'Host',
      port: 'Port',
      password: 'Password',
      switch: 'Switch',
      logicalOperator: 'Logical operator',
      switchOperatorOptions: {
        equal: 'equal',
        notEqual: 'notEqual',
        gt: 'Greater than',
        ge: 'Greater equal',
        lt: 'Less than',
        le: 'Less equal',
        contains: 'Contains',
        notContains: 'Not contains',
        startWith: 'Start with',
        endWith: 'End with',
        empty: 'Empty',
        notEmpty: 'Not empty',
      },
      switchLogicOperatorOptions: {
        and: 'And',
        or: 'Or',
      },
      operator: 'Operator',
      value: 'Value',
      useTemplate: 'Use this template',
      wenCai: 'WenCai',
      queryType: 'Query type',
      wenCaiDescription:
        'A component that obtains financial information, including stock prices and funding news, from a wide range of financial websites.',
      wenCaiQueryTypeOptions: {
        stock: 'stock',
        zhishu: 'index',
        fund: 'fund',
        hkstock: 'Hong Kong shares',
        usstock: 'US stock market',
        threeboard: 'New OTC Market',
        conbond: 'Convertible Bond',
        insurance: 'insurance',
        futures: 'futures',
        lccp: 'Financing',
        foreign_exchange: 'Foreign currency',
      },
      akShare: 'AkShare',
      akShareDescription:
        'A component that obtains news about stocks from https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'A component that queries information about a publicly traded company using its ticker symbol.',
      crawler: 'Web Crawler',
      crawlerDescription:
        'A component that crawls HTML source code from a specified URL.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Content',
      },
      extractType: 'Extract type',
      info: 'Info',
      history: 'History',
      financials: 'Financials',
      balanceSheet: 'Balance sheet',
      cashFlowStatement: 'Cash flow statement',
      jin10: 'Jin10',
      jin10Description:
        'A component that retrieves financial information from the Jin10 Open Platform, including news updates, calendars, quotes, and references.',
      flashType: 'Flash type',
      filter: 'Filter',
      contain: 'Contain',
      calendarType: 'Calendar type',
      calendarDatashape: 'Calendar datashape',
      symbolsDatatype: 'Symbols datatype',
      symbolsType: 'Symbols type',
      jin10TypeOptions: {
        flash: 'Quick News',
        calendar: 'Calendar',
        symbols: 'quotes',
        news: 'reference',
      },
      jin10FlashTypeOptions: {
        '1': 'Market News',
        '2': ' Futures News',
        '3': 'US-Hong Kong News',
        '4': 'A-Share News',
        '5': 'Commodities & Forex News',
      },
      jin10CalendarTypeOptions: {
        cj: 'Macroeconomic Data Calendar',
        qh: ' Futures Calendar',
        hk: 'Hong Kong Stock Market Calendar',
        us: 'US Stock Market Calendar',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Data',
        event: ' Event',
        holiday: 'Holiday',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Commodity Quotes',
        FOREX: ' Forex Quotes',
        FUTURE: 'International Market Quotes',
        CRYPTO: 'Cryptocurrency Quotes',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Commodity List',
        quotes: ' Latest Market Quotes',
      },
      concentrator: 'Concentrator',
      concentratorDescription:
        'A component that receives the output from the upstream component and passes it on as input to the downstream components.',
      tuShare: 'TuShare',
      tuShareDescription:
        'A component that obtains financial news briefs from mainstream financial websites, aiding industry and quantitative research.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Straight flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Token',
      src: 'Source',
      startDate: 'Start date',
      endDate: 'End date',
      keyword: 'Keyword',
      note: 'Note',
      noteDescription: 'Note',
      notePlaceholder: 'Please enter a note',
      invoke: 'Invoke',
      invokeDescription: `A component capable of calling remote services, using other components' outputs or constants as inputs.`,
      url: 'Url',
      method: 'Method',
      timeout: 'Timeout',
      headers: 'Headers',
      cleanHtml: 'Clean HTML',
      cleanHtmlTip:
        'If the response is HTML formatted and only the primary content wanted, please toggle it on.',
      reference: 'Reference',
      input: 'Input',
      output: 'Output',
      parameter: 'Parameter',
      howUseId: 'How to use agent ID?',
      content: 'Content',
      operationResults: 'Operation Results',
      autosaved: 'Autosaved',
      optional: 'Optional',
      pasteFileLink: 'Paste file link',
      testRun: 'Test Run',
      template: 'Template',
      templateDescription:
        'A component that formats the output of another component.',
      emailComponent: 'Email',
      emailDescription: 'Send an email to a specified address.',
      smtpServer: 'SMTP Server',
      smtpPort: 'SMTP Port',
      senderEmail: 'Sender Email',
      authCode: 'Authorization Code',
      senderName: 'Sender Name',
      toEmail: 'Recipient Email',
      ccEmail: 'CC Email',
      emailSubject: 'Subject',
      emailContent: 'Content',
      smtpServerRequired: 'Please input SMTP server address',
      senderEmailRequired: 'Please input sender email',
      authCodeRequired: 'Please input authorization code',
      toEmailRequired: 'Please input recipient email',
      emailContentRequired: 'Please input email content',
      emailSentSuccess: 'Email sent successfully',
      emailSentFailed: 'Failed to send email',
      dynamicParameters: 'Dynamic Parameters',
      jsonFormatTip:
        'Upstream component should provide JSON string in following format:',
      toEmailTip: 'to_email: Recipient email (Required)',
      ccEmailTip: 'cc_email: CC email (Optional)',
      subjectTip: 'subject: Email subject (Optional)',
      contentTip: 'content: Email content (Optional)',
      jsonUploadTypeErrorMessage: 'Please upload json file',
      jsonUploadContentErrorMessage: 'json file error',
      iteration: 'Iteration',
      iterationDescription: `This component firstly split the input into array by "delimiter".
Perform the same operation steps on the elements in the array in sequence until all results are output, which can be understood as a task batch processor.

For example, within the long text translation iteration node, if all content is input to the LLM node, the single conversation limit may be reached. The upstream node can first split the long text into multiple fragments, and cooperate with the iterative node to perform batch translation on each fragment to avoid reaching the LLM message limit for a single conversation.`,
      delimiterTip: `
This delimiter is used to split the input text into several text pieces echo of which will be performed as input item of each iteration.`,
      delimiterOptions: {
        comma: 'Comma',
        lineBreak: 'Line break',
        tab: 'Tab',
        underline: 'Underline',
        diagonal: 'Diagonal',
        minus: 'Minus',
        semicolon: 'Semicolon',
      },
      addVariable: 'Add variable',
      variableSettings: 'Variable settings',
      globalVariables: 'Global variables',
      systemPrompt: 'System prompt',
    },
    footer: {
      profile: 'All rights reserved @ React',
    },
    layout: {
      file: 'file',
      knowledge: 'knowledge',
      chat: 'chat',
    },
    reAnalyzeModal: {
      message: 'Do you want to delete all existing chunks?',
      warningText: 'Caution: Manual changes to chunks will be lost.',
      manageChunks: 'Manage chunks',
      cancel: 'Cancel',
      keep: 'Keep',
      continue: 'Continue',
      delete: 'Delete',
    },
    setTagsModal: {
      message:
        'Here you can view and edit the keywords of all selected files. However, only those keywords are displayed that are common to all chunks of a file and are the same across all files.',
      warningMessage:
        '**Please note that if no chunks exist for a selected file, no tags can be created.**',
      manageTags: 'Manage keywords',
      tags: 'Keywords',
      apply: 'Apply',
    },
    evaluation: {
      evaluation: 'Evaluation',
      question: 'Question',
      answer: 'Answer',
      feedback: 'Feedback',
      actions: 'Actions',
      showHistory: 'Show history',
      dialogNotFound: 'Dialog not found',
      export: 'Export',
      positiveFeedbacks: 'Positive feedbacks',
      negativeFeedbacks: 'Negative feedbacks',
      allMessages: 'All messages',
      showTotalLabel: `Total {{total}} feedbacks`,
      fromStart: 'From the beginning',
      untilNow: 'Until now',
      filterDateRange: 'Filter date range',
      sessions: 'Sessions',
      activeSessions: 'Active sessions',
      interactions: 'Interactions',
      meanInteractionsPerActiveSession: '⌀ Interactions per session',
      ratedAnswers: 'Rated Answers',
      likes: '  ↳ Likes',
      dislikes: '  ↳ Dislikes',
      feedbackAndMessages: 'Feedback & Messages',
      feedbackFlagCountsLabel: 'Number of feedback flags',
      feedbackFlags: {
        wrong: 'Wrong',
        harmful: 'Harmful/Dangerous/Illegal',
        offensive: 'Offensive/Discriminatory/Unfair',
        repetition: 'Repetition',
        unclear: 'Unclear',
        insufficient: 'Insufficient',
        other: 'Other',
      },
      metric: 'Metric',
      value: 'Value',
      sessionStart: 'Session Start',
      sessionId: 'Session ID',
      sessionTopic: 'Title',
      messageCount: 'Messages',
      sessionFallbackTitle: 'Session {{id}}',
      showTotalSessionsLabel: `Total {{total}} sessions`,
      statsLoading: 'Loading statistics …',
      metricHelp: {
        sessions:
          'The chat was opened. This can already happen automatically when the page loads. Only stored conversations are counted.',
        activeSessions: 'Sessions in which the user sent at least one message.',
        interactions: 'Number of messages sent by users.',
        meanInteractionsPerActiveSession:
          'User messages divided by active sessions.',
        ratedAnswers:
          'Answers from the buddy that were rated with "like" or "dislike".',
        likes:
          'Answers rated with "like"; in brackets their share of all rated answers.',
        dislikes:
          'Answers rated with "dislike"; in brackets their share of all rated answers.',
        feedbackFlags:
          'Reasons users selected with a "dislike". They break those ratings down further.',
      },
    },
    vad: {
      connectionError: 'Connection error occurred. Please try again later.',
      unknownMicError:
        'Unknown microphone error. Please check your device settings and reload the page.',
    },
    speechCall: {
      answerLabel: 'Answer:',
      generatingAnswer: 'Generating answer...',
      detectingSpeech: 'Detecting speech...',
      listeningForSpeech: 'Waiting for speech input...',
      waitingForMicrophone: 'Waiting for microphone permission...',
      microphoneAccessDenied: 'No access to the microphone.',
      microphoneAccessDeniedDescription:
        'No access to the microphone. Please check your browser settings and reload the page.',
      requestAnswerError: 'Error requesting answer.',
      requestAnswerErrorDescription:
        'Error requesting answer. Please modify your input and try again later.',
      preparingAudio: 'Preparing audio, waiting for the full answer...',
      ttsUnavailable: 'Speech output is unavailable.',
      ttsUnavailableDescription:
        'The answer could not be read aloud. Please check your network connection and try again later.',
    },
    buddyEval: {
      advancedMode: 'Advanced Mode',
      importDataset: 'Import dataset',
      importFormatError: 'Only .xls, .xlsx and .csv files are supported.',
      importFormatHints: {
        title: 'Notes on Data Format',
        description:
          'All columns from the input file are adopted that have the following names as headers in the first row (case is ignored):',
        columnNameTitle: 'Column Name',
        columnIdDesc: 'ID of the question.',
        columnQuestionDesc: 'The question to answer.',
        columnQuestionTitle: 'Question',
        columnExpectedAnswerDesc: 'The desired answer (Gold-Standard).',
        columnExpectedAnswerTitle: 'Expected Answer',
        columnActualAnswerDesc: `Answer of the Buddy (Optional: if the answer to evaluate was already generated and shouldn't be dynamically generated during the test).`,
        columnActualAnswerTitle: `Actual Answer`,
        missingData: `Couldn't find data to import. Please check the format of you data. Please also take note of the "Notes on Data Format".`,
      },
      importNotImplemented: 'Import feature is not yet implemented.',
      importDragHint: 'Drag file here or click to select',
      importFormatHint: 'Supported formats: .xls, .xlsx, .csv',
      importSuccess: 'Dataset imported successfully.',
      unsavedChangesTitle: 'Unsaved changes',
      unsavedChangesContent:
        'You have unsaved changes. Would you like to save or discard them?',
      discardChanges: 'Discard',
      distribution: 'Distribution',
      runSpread: 'Spread between runs',
      runSpreadTip:
        'How much the overall result varies from run to run, computed over the mean of each run. Small values mean the buddy answers consistently.',
      answerSpread: 'Spread over all answers',
      answerSpreadTip:
        'How far the scores of individual answers lie apart, across all questions and runs. 0 and 1 only mean that at least one answer was fully wrong and one fully right.',
      // Test Configs
      datasets: 'Datasets',
      testConfigs: 'Test Configs',
      testRuns: 'Test Runs',
      testRun: 'Test Run',
      testcaseCount: 'Testcases',
      searchConfigs: 'Search configs...',
      createConfig: 'Create Config',
      editConfig: 'Edit Config',
      configDetails: 'Config Details',
      configNamePlaceholder: 'Config name',
      configDescriptionPlaceholder: 'Optional description',
      configName: 'Config',
      noTestcases: 'No testcases configured',
      modelClassName: 'Model Class',
      model: 'Model',
      customEndpoint: 'Endpoint',
      chatId: 'Chat ID',
      taskClassName: 'Task Class',
      prompt: 'Prompt',
      dataset: 'Dataset',
      // Test Runs
      runStatus: 'Status',
      progress: 'Progress',
      searchRuns: 'Search runs...',
      startRun: 'Start Run',
      cancelRun: 'Cancel Run',
      confirmCancelRun: 'Cancel this run?',
      confirmDeleteRun: 'Delete this run?',
      viewResults: 'View results',
      exportRun: 'Export as Excel',
      exportRunFailed: 'Export failed',
      runDetails: 'Run Details',
      startTime: 'Started',
      endTime: 'Ended',
      results: 'Results',
      noResults: 'No results',
      overallSummary: 'Overall Summary',
      successRate: 'Success Rate',
      evaluations: 'Evaluations',
      unanswered: 'Unanswered',
      erroredMetrics: 'Metric errors',
      metricError: 'error',
      customMetrics: 'Custom metrics',
      customMetricsTip:
        'Run in addition to the standard metrics. A run always uses the current version of each metric at start time.',
      noCustomMetrics: 'No custom metrics yet',
      createMetric: 'Create metric',
      editMetric: 'Edit metric',
      metricPrompt: 'Metric prompt',
      metricPromptPlaceholder:
        'What should the judge model assess in the answer? Question, answer and expected answer are appended automatically.',
      metricType: 'Result type',
      metricTypeNumeric: 'Numeric',
      metricTypeEnum: 'Categories',
      metricMin: 'Minimum',
      metricMax: 'Maximum',
      metricMinBelowMax: 'The minimum must be smaller than the maximum',
      metricEnumValues: 'Allowed values',
      metricEnumLabel: 'Label',
      metricEnumScore: 'Score (0–1)',
      metricEnumUnique: 'Labels must be unique',
      metricEnumMin: 'Enter at least two values',
      addEnumValue: 'Add value',
      metricThreshold: 'Pass threshold',
      metricThresholdTipNumeric:
        "On the metric's own scale. Defaults to the middle of the scale.",
      metricThresholdTipEnum:
        'Minimum score (0–1) for a category to count as passed. Defaults to 0.5.',
      metricVersion: 'Version',
      deleteMetricConfirm:
        'Delete this metric? Finished runs keep their results, but configs that use it can no longer be started.',
      metricNotFound: 'This metric no longer exists.',
      metricNameTaken: 'A metric with this name already exists.',
      metricNameReserved:
        'The name must not end with "[GEval]"; that suffix is reserved for the standard metrics.',
      metricMissing:
        'This config uses deleted metrics: {{detail}}. Please edit the config.',
      coarseScores:
        'Coarse GEval scores: the judge model does not support logprobs',
      coarseScoresHint:
        'GEval can only report multiples of 0.1 with {{models}}. Switch the evaluation model to gpt-4.1 for finer scores.',
      evalInput: 'Input',
      evalStatus: 'Status',
      actualOutput: 'Actual Output',
      expectedOutput: 'Expected Output',
      metricName: 'Metric',
      metricReason: 'Reason',
      answerDuration: 'Answer retrieval duration',
      evalDuration: 'Evaluation duration',
      repeat: 'Repeat',
      repeatTip: 'Number of times the evaluation is repeated',
      noDialogSelected: 'No dialog selected',
      runStarted: 'Evaluation run started',
      runStartFailed: 'Failed to start run',
      runConfigLoadFailed: "Could not load this run's config",
      // Testcases & Tasks
      addTestcase: 'Add Testcase',
      addTask: 'Add Task',
      testcaseName: 'Testcase Name',
      taskName: 'Task Name',
      tasks: 'Tasks',
      modelPlaceholder: 'e.g. gpt-4o',
      runId: 'Run ID',
      testsPassed: 'passed',
      atLeastOneTestcase: 'At least one testcase is required',
      atLeastOneTask: 'At least one task is required',
      datasetRequired: 'Please pick a dataset',
      testcaseNamePlaceholder: 'Testcase name',
      modelClassNamePlaceholder: 'e.g. OpenAI',
      customEndpointPlaceholder: 'Optional endpoint URL',
      chatIdPlaceholder: 'Optional Chat ID',
      taskNamePlaceholder: 'Task name',
      taskClassNamePlaceholder: 'e.g. AnswerPerformanceEval',
      promptPlaceholder: 'Evaluation prompt',
    },
  },
};
